import { IResultadoCircunscripcion } from '../circunscripciones/[circunscripcion]/components/CandidatesSection/CandidatesTable'

const ganadoresCircunscripcionEmpty: IResultadoCircunscripcion[] = JSON.parse(`[
    {
      "circunscripcion": "1",
      "resultados": [
        {
          "id_candidato": "sergio_humberto_rios_gamboa",
          "id_candidato_servel": 16556928,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "macarena_riveros_oyarzo",
          "id_candidato_servel": 13863895,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "ernesto_rodrigo_plasencia_rojas",
          "id_candidato_servel": 10728965,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "karla_angelica_anes_gajardo",
          "id_candidato_servel": 14102768,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "nora_del_carmen_bugueno_aguilera",
          "id_candidato_servel": 13412628,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "salvador_urrutia_cardenas",
          "id_candidato_servel": 4738039,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "gloria_lillo_rebolledo",
          "id_candidato_servel": 11888643,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "raul_ramon_castro_letelier",
          "id_candidato_servel": 4847637,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "juan_manuel_carrasco_barra",
          "id_candidato_servel": 13999294,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "josefina_letelier_larrain",
          "id_candidato_servel": 19081767,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "raul_gil_gonzalez",
          "id_candidato_servel": 7024697,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "brunella_vinet_mattasoglio",
          "id_candidato_servel": 12608155,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "daniel_alexandro_bunster_ruiz",
          "id_candidato_servel": 16937042,
          "id_pacto": 377,
          "id_partido": 190,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jocelyn_ormeno_lee",
          "id_candidato_servel": 13415976,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "rodrigo_leonardo_munoz_ponce",
          "id_candidato_servel": 9072069,
          "id_pacto": 377,
          "id_partido": 137,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "miriam_arenas_sandoval",
          "id_candidato_servel": 5501238,
          "id_pacto": 377,
          "id_partido": 137,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carlos_miguel_alvarado_aguirre",
          "id_candidato_servel": 7214480,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "francisca_marina_cavieres_diaz",
          "id_candidato_servel": 20217726,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "diego_alberto_vargas_castillo",
          "id_candidato_servel": 20218020,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jacqueline_carolina_boero_carvajal",
          "id_candidato_servel": 11505821,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2822,
          "resultados": [
            {
              "id_candidato": "salvador_urrutia_cardenas",
              "id_candidato_servel": 4738039,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_ramon_castro_letelier",
              "id_candidato_servel": 4847637,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_arenas_sandoval",
              "id_candidato_servel": 5501238,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_gil_gonzalez",
              "id_candidato_servel": 7024697,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_miguel_alvarado_aguirre",
              "id_candidato_servel": 7214480,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_leonardo_munoz_ponce",
              "id_candidato_servel": 9072069,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ernesto_rodrigo_plasencia_rojas",
              "id_candidato_servel": 10728965,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_carolina_boero_carvajal",
              "id_candidato_servel": 11505821,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_lillo_rebolledo",
              "id_candidato_servel": 11888643,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brunella_vinet_mattasoglio",
              "id_candidato_servel": 12608155,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nora_del_carmen_bugueno_aguilera",
              "id_candidato_servel": 13412628,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jocelyn_ormeno_lee",
              "id_candidato_servel": 13415976,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_riveros_oyarzo",
              "id_candidato_servel": 13863895,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_manuel_carrasco_barra",
              "id_candidato_servel": 13999294,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karla_angelica_anes_gajardo",
              "id_candidato_servel": 14102768,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_humberto_rios_gamboa",
              "id_candidato_servel": 16556928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alexandro_bunster_ruiz",
              "id_candidato_servel": 16937042,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefina_letelier_larrain",
              "id_candidato_servel": 19081767,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_marina_cavieres_diaz",
              "id_candidato_servel": 20217726,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "diego_alberto_vargas_castillo",
              "id_candidato_servel": 20218020,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2823,
          "resultados": [
            {
              "id_candidato": "salvador_urrutia_cardenas",
              "id_candidato_servel": 4738039,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_ramon_castro_letelier",
              "id_candidato_servel": 4847637,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_arenas_sandoval",
              "id_candidato_servel": 5501238,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_gil_gonzalez",
              "id_candidato_servel": 7024697,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_miguel_alvarado_aguirre",
              "id_candidato_servel": 7214480,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_leonardo_munoz_ponce",
              "id_candidato_servel": 9072069,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ernesto_rodrigo_plasencia_rojas",
              "id_candidato_servel": 10728965,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_carolina_boero_carvajal",
              "id_candidato_servel": 11505821,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_lillo_rebolledo",
              "id_candidato_servel": 11888643,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brunella_vinet_mattasoglio",
              "id_candidato_servel": 12608155,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nora_del_carmen_bugueno_aguilera",
              "id_candidato_servel": 13412628,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jocelyn_ormeno_lee",
              "id_candidato_servel": 13415976,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_riveros_oyarzo",
              "id_candidato_servel": 13863895,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_manuel_carrasco_barra",
              "id_candidato_servel": 13999294,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karla_angelica_anes_gajardo",
              "id_candidato_servel": 14102768,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_humberto_rios_gamboa",
              "id_candidato_servel": 16556928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alexandro_bunster_ruiz",
              "id_candidato_servel": 16937042,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefina_letelier_larrain",
              "id_candidato_servel": 19081767,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_marina_cavieres_diaz",
              "id_candidato_servel": 20217726,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "diego_alberto_vargas_castillo",
              "id_candidato_servel": 20218020,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2824,
          "resultados": [
            {
              "id_candidato": "salvador_urrutia_cardenas",
              "id_candidato_servel": 4738039,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_ramon_castro_letelier",
              "id_candidato_servel": 4847637,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_arenas_sandoval",
              "id_candidato_servel": 5501238,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_gil_gonzalez",
              "id_candidato_servel": 7024697,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_miguel_alvarado_aguirre",
              "id_candidato_servel": 7214480,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_leonardo_munoz_ponce",
              "id_candidato_servel": 9072069,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ernesto_rodrigo_plasencia_rojas",
              "id_candidato_servel": 10728965,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_carolina_boero_carvajal",
              "id_candidato_servel": 11505821,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_lillo_rebolledo",
              "id_candidato_servel": 11888643,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brunella_vinet_mattasoglio",
              "id_candidato_servel": 12608155,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nora_del_carmen_bugueno_aguilera",
              "id_candidato_servel": 13412628,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jocelyn_ormeno_lee",
              "id_candidato_servel": 13415976,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_riveros_oyarzo",
              "id_candidato_servel": 13863895,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_manuel_carrasco_barra",
              "id_candidato_servel": 13999294,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karla_angelica_anes_gajardo",
              "id_candidato_servel": 14102768,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_humberto_rios_gamboa",
              "id_candidato_servel": 16556928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alexandro_bunster_ruiz",
              "id_candidato_servel": 16937042,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefina_letelier_larrain",
              "id_candidato_servel": 19081767,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_marina_cavieres_diaz",
              "id_candidato_servel": 20217726,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "diego_alberto_vargas_castillo",
              "id_candidato_servel": 20218020,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2825,
          "resultados": [
            {
              "id_candidato": "salvador_urrutia_cardenas",
              "id_candidato_servel": 4738039,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_ramon_castro_letelier",
              "id_candidato_servel": 4847637,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_arenas_sandoval",
              "id_candidato_servel": 5501238,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_gil_gonzalez",
              "id_candidato_servel": 7024697,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_miguel_alvarado_aguirre",
              "id_candidato_servel": 7214480,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_leonardo_munoz_ponce",
              "id_candidato_servel": 9072069,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ernesto_rodrigo_plasencia_rojas",
              "id_candidato_servel": 10728965,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_carolina_boero_carvajal",
              "id_candidato_servel": 11505821,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_lillo_rebolledo",
              "id_candidato_servel": 11888643,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brunella_vinet_mattasoglio",
              "id_candidato_servel": 12608155,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nora_del_carmen_bugueno_aguilera",
              "id_candidato_servel": 13412628,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jocelyn_ormeno_lee",
              "id_candidato_servel": 13415976,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_riveros_oyarzo",
              "id_candidato_servel": 13863895,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_manuel_carrasco_barra",
              "id_candidato_servel": 13999294,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karla_angelica_anes_gajardo",
              "id_candidato_servel": 14102768,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_humberto_rios_gamboa",
              "id_candidato_servel": 16556928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alexandro_bunster_ruiz",
              "id_candidato_servel": 16937042,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefina_letelier_larrain",
              "id_candidato_servel": 19081767,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_marina_cavieres_diaz",
              "id_candidato_servel": 20217726,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "diego_alberto_vargas_castillo",
              "id_candidato_servel": 20218020,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "2",
      "resultados": [
        {
          "id_candidato": "claudia_evelyn_villegas_carvajal",
          "id_candidato_servel": 15017736,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "marcela_ortega_saez",
          "id_candidato_servel": 11841040,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "francisca_ester_vargas_pallero",
          "id_candidato_servel": 18004190,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carlos_alberto_mella_latorre",
          "id_candidato_servel": 6720037,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "luis_dixon_vergara_pizarro",
          "id_candidato_servel": 12447501,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "sergio_bitar_chacra",
          "id_candidato_servel": 4227646,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "pedro_andres_vasquez_neira",
          "id_candidato_servel": 14271718,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "norma_cristina_cordova_correa",
          "id_candidato_servel": 15002239,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "nestor_jofre_nunez",
          "id_candidato_servel": 5348422,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "romina_terrazas_barraza",
          "id_candidato_servel": 16592912,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "mauricio_schmidt_silva",
          "id_candidato_servel": 10586276,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "pilar_barrientos_hernandez",
          "id_candidato_servel": 9225586,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "rosa_maria_ojeda_menares",
          "id_candidato_servel": 13991861,
          "id_pacto": 377,
          "id_partido": 190,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "kurt_hener_perez",
          "id_candidato_servel": 8512604,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "roberto_flavio_cortez_rojas",
          "id_candidato_servel": 5595090,
          "id_pacto": 377,
          "id_partido": 6,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "romina_carolina_ramos_rodriguez",
          "id_candidato_servel": 16486080,
          "id_pacto": 377,
          "id_partido": 143,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "sebastian_esteban_parraguez_gonzalez",
          "id_candidato_servel": 16556679,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "leonardo_andres_ramos_iriarte",
          "id_candidato_servel": 18264399,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "andrea_elizabeth_duenas_chavez",
          "id_candidato_servel": 13416397,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "ninoska_esther_payauna_vilca",
          "id_candidato_servel": 17094561,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2501,
          "resultados": [
            {
              "id_candidato": "sergio_bitar_chacra",
              "id_candidato_servel": 4227646,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nestor_jofre_nunez",
              "id_candidato_servel": 5348422,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_flavio_cortez_rojas",
              "id_candidato_servel": 5595090,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_alberto_mella_latorre",
              "id_candidato_servel": 6720037,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kurt_hener_perez",
              "id_candidato_servel": 8512604,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_barrientos_hernandez",
              "id_candidato_servel": 9225586,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_schmidt_silva",
              "id_candidato_servel": 10586276,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_ortega_saez",
              "id_candidato_servel": 11841040,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_dixon_vergara_pizarro",
              "id_candidato_servel": 12447501,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_elizabeth_duenas_chavez",
              "id_candidato_servel": 13416397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_maria_ojeda_menares",
              "id_candidato_servel": 13991861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_vasquez_neira",
              "id_candidato_servel": 14271718,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "norma_cristina_cordova_correa",
              "id_candidato_servel": 15002239,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_evelyn_villegas_carvajal",
              "id_candidato_servel": 15017736,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "romina_carolina_ramos_rodriguez",
              "id_candidato_servel": 16486080,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_esteban_parraguez_gonzalez",
              "id_candidato_servel": 16556679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "romina_terrazas_barraza",
              "id_candidato_servel": 16592912,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ninoska_esther_payauna_vilca",
              "id_candidato_servel": 17094561,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_ester_vargas_pallero",
              "id_candidato_servel": 18004190,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leonardo_andres_ramos_iriarte",
              "id_candidato_servel": 18264399,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2502,
          "resultados": [
            {
              "id_candidato": "sergio_bitar_chacra",
              "id_candidato_servel": 4227646,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nestor_jofre_nunez",
              "id_candidato_servel": 5348422,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_flavio_cortez_rojas",
              "id_candidato_servel": 5595090,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_alberto_mella_latorre",
              "id_candidato_servel": 6720037,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kurt_hener_perez",
              "id_candidato_servel": 8512604,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_barrientos_hernandez",
              "id_candidato_servel": 9225586,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_schmidt_silva",
              "id_candidato_servel": 10586276,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_ortega_saez",
              "id_candidato_servel": 11841040,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_dixon_vergara_pizarro",
              "id_candidato_servel": 12447501,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_elizabeth_duenas_chavez",
              "id_candidato_servel": 13416397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_maria_ojeda_menares",
              "id_candidato_servel": 13991861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_vasquez_neira",
              "id_candidato_servel": 14271718,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "norma_cristina_cordova_correa",
              "id_candidato_servel": 15002239,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_evelyn_villegas_carvajal",
              "id_candidato_servel": 15017736,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "romina_carolina_ramos_rodriguez",
              "id_candidato_servel": 16486080,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_esteban_parraguez_gonzalez",
              "id_candidato_servel": 16556679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "romina_terrazas_barraza",
              "id_candidato_servel": 16592912,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ninoska_esther_payauna_vilca",
              "id_candidato_servel": 17094561,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_ester_vargas_pallero",
              "id_candidato_servel": 18004190,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leonardo_andres_ramos_iriarte",
              "id_candidato_servel": 18264399,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2503,
          "resultados": [
            {
              "id_candidato": "sergio_bitar_chacra",
              "id_candidato_servel": 4227646,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nestor_jofre_nunez",
              "id_candidato_servel": 5348422,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_flavio_cortez_rojas",
              "id_candidato_servel": 5595090,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_alberto_mella_latorre",
              "id_candidato_servel": 6720037,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kurt_hener_perez",
              "id_candidato_servel": 8512604,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_barrientos_hernandez",
              "id_candidato_servel": 9225586,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_schmidt_silva",
              "id_candidato_servel": 10586276,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_ortega_saez",
              "id_candidato_servel": 11841040,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_dixon_vergara_pizarro",
              "id_candidato_servel": 12447501,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_elizabeth_duenas_chavez",
              "id_candidato_servel": 13416397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_maria_ojeda_menares",
              "id_candidato_servel": 13991861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_vasquez_neira",
              "id_candidato_servel": 14271718,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "norma_cristina_cordova_correa",
              "id_candidato_servel": 15002239,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_evelyn_villegas_carvajal",
              "id_candidato_servel": 15017736,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "romina_carolina_ramos_rodriguez",
              "id_candidato_servel": 16486080,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_esteban_parraguez_gonzalez",
              "id_candidato_servel": 16556679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "romina_terrazas_barraza",
              "id_candidato_servel": 16592912,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ninoska_esther_payauna_vilca",
              "id_candidato_servel": 17094561,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_ester_vargas_pallero",
              "id_candidato_servel": 18004190,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leonardo_andres_ramos_iriarte",
              "id_candidato_servel": 18264399,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2504,
          "resultados": [
            {
              "id_candidato": "sergio_bitar_chacra",
              "id_candidato_servel": 4227646,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nestor_jofre_nunez",
              "id_candidato_servel": 5348422,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_flavio_cortez_rojas",
              "id_candidato_servel": 5595090,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_alberto_mella_latorre",
              "id_candidato_servel": 6720037,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kurt_hener_perez",
              "id_candidato_servel": 8512604,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_barrientos_hernandez",
              "id_candidato_servel": 9225586,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_schmidt_silva",
              "id_candidato_servel": 10586276,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_ortega_saez",
              "id_candidato_servel": 11841040,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_dixon_vergara_pizarro",
              "id_candidato_servel": 12447501,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_elizabeth_duenas_chavez",
              "id_candidato_servel": 13416397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_maria_ojeda_menares",
              "id_candidato_servel": 13991861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_vasquez_neira",
              "id_candidato_servel": 14271718,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "norma_cristina_cordova_correa",
              "id_candidato_servel": 15002239,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_evelyn_villegas_carvajal",
              "id_candidato_servel": 15017736,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "romina_carolina_ramos_rodriguez",
              "id_candidato_servel": 16486080,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_esteban_parraguez_gonzalez",
              "id_candidato_servel": 16556679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "romina_terrazas_barraza",
              "id_candidato_servel": 16592912,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ninoska_esther_payauna_vilca",
              "id_candidato_servel": 17094561,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_ester_vargas_pallero",
              "id_candidato_servel": 18004190,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leonardo_andres_ramos_iriarte",
              "id_candidato_servel": 18264399,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2505,
          "resultados": [
            {
              "id_candidato": "sergio_bitar_chacra",
              "id_candidato_servel": 4227646,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nestor_jofre_nunez",
              "id_candidato_servel": 5348422,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_flavio_cortez_rojas",
              "id_candidato_servel": 5595090,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_alberto_mella_latorre",
              "id_candidato_servel": 6720037,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kurt_hener_perez",
              "id_candidato_servel": 8512604,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_barrientos_hernandez",
              "id_candidato_servel": 9225586,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_schmidt_silva",
              "id_candidato_servel": 10586276,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_ortega_saez",
              "id_candidato_servel": 11841040,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_dixon_vergara_pizarro",
              "id_candidato_servel": 12447501,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_elizabeth_duenas_chavez",
              "id_candidato_servel": 13416397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_maria_ojeda_menares",
              "id_candidato_servel": 13991861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_vasquez_neira",
              "id_candidato_servel": 14271718,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "norma_cristina_cordova_correa",
              "id_candidato_servel": 15002239,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_evelyn_villegas_carvajal",
              "id_candidato_servel": 15017736,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "romina_carolina_ramos_rodriguez",
              "id_candidato_servel": 16486080,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_esteban_parraguez_gonzalez",
              "id_candidato_servel": 16556679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "romina_terrazas_barraza",
              "id_candidato_servel": 16592912,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ninoska_esther_payauna_vilca",
              "id_candidato_servel": 17094561,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_ester_vargas_pallero",
              "id_candidato_servel": 18004190,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leonardo_andres_ramos_iriarte",
              "id_candidato_servel": 18264399,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2506,
          "resultados": [
            {
              "id_candidato": "sergio_bitar_chacra",
              "id_candidato_servel": 4227646,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nestor_jofre_nunez",
              "id_candidato_servel": 5348422,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_flavio_cortez_rojas",
              "id_candidato_servel": 5595090,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_alberto_mella_latorre",
              "id_candidato_servel": 6720037,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kurt_hener_perez",
              "id_candidato_servel": 8512604,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_barrientos_hernandez",
              "id_candidato_servel": 9225586,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_schmidt_silva",
              "id_candidato_servel": 10586276,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_ortega_saez",
              "id_candidato_servel": 11841040,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_dixon_vergara_pizarro",
              "id_candidato_servel": 12447501,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_elizabeth_duenas_chavez",
              "id_candidato_servel": 13416397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_maria_ojeda_menares",
              "id_candidato_servel": 13991861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_vasquez_neira",
              "id_candidato_servel": 14271718,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "norma_cristina_cordova_correa",
              "id_candidato_servel": 15002239,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_evelyn_villegas_carvajal",
              "id_candidato_servel": 15017736,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "romina_carolina_ramos_rodriguez",
              "id_candidato_servel": 16486080,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_esteban_parraguez_gonzalez",
              "id_candidato_servel": 16556679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "romina_terrazas_barraza",
              "id_candidato_servel": 16592912,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ninoska_esther_payauna_vilca",
              "id_candidato_servel": 17094561,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_ester_vargas_pallero",
              "id_candidato_servel": 18004190,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leonardo_andres_ramos_iriarte",
              "id_candidato_servel": 18264399,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2507,
          "resultados": [
            {
              "id_candidato": "sergio_bitar_chacra",
              "id_candidato_servel": 4227646,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nestor_jofre_nunez",
              "id_candidato_servel": 5348422,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_flavio_cortez_rojas",
              "id_candidato_servel": 5595090,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_alberto_mella_latorre",
              "id_candidato_servel": 6720037,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kurt_hener_perez",
              "id_candidato_servel": 8512604,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_barrientos_hernandez",
              "id_candidato_servel": 9225586,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_schmidt_silva",
              "id_candidato_servel": 10586276,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_ortega_saez",
              "id_candidato_servel": 11841040,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_dixon_vergara_pizarro",
              "id_candidato_servel": 12447501,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_elizabeth_duenas_chavez",
              "id_candidato_servel": 13416397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_maria_ojeda_menares",
              "id_candidato_servel": 13991861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_vasquez_neira",
              "id_candidato_servel": 14271718,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "norma_cristina_cordova_correa",
              "id_candidato_servel": 15002239,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_evelyn_villegas_carvajal",
              "id_candidato_servel": 15017736,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "romina_carolina_ramos_rodriguez",
              "id_candidato_servel": 16486080,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_esteban_parraguez_gonzalez",
              "id_candidato_servel": 16556679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "romina_terrazas_barraza",
              "id_candidato_servel": 16592912,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ninoska_esther_payauna_vilca",
              "id_candidato_servel": 17094561,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_ester_vargas_pallero",
              "id_candidato_servel": 18004190,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leonardo_andres_ramos_iriarte",
              "id_candidato_servel": 18264399,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "3",
      "resultados": [
        {
          "id_candidato": "sindy_tessa_gonzalez_salini",
          "id_candidato_servel": 9542426,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "maria_cangana_loyola",
          "id_candidato_servel": 11721751,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carmen_montoya_mayorga",
          "id_candidato_servel": 10298243,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jorge_andres_alvarez_tapia",
          "id_candidato_servel": 20817869,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "juan_enrique_moraga_mena",
          "id_candidato_servel": 13014404,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "tammy_soledad_verdugo_reyes",
          "id_candidato_servel": 13289217,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "freddy_vinales_vinales",
          "id_candidato_servel": 16924700,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "doris_nerta_navarro_figueroa",
          "id_candidato_servel": 8577508,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "marcelo_encina_munoz",
          "id_candidato_servel": 15085033,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "patricio_maldonado_lavado",
          "id_candidato_servel": 14499183,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "siomara_vanessa_molina_flores",
          "id_candidato_servel": 19952161,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carlos_solar_barrios",
          "id_candidato_servel": 7166120,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "nalto_espinoza_hurtado",
          "id_candidato_servel": 6273728,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "katherine_lopez_rivera",
          "id_candidato_servel": 14109173,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "pablo_pomareda_echeverria",
          "id_candidato_servel": 16245075,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "daniela_castro_araya",
          "id_candidato_servel": 16203260,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jose_cristian_mardones_gallardo",
          "id_candidato_servel": 10952965,
          "id_pacto": 377,
          "id_partido": 6,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "johana_cristina_rivera_tejerina",
          "id_candidato_servel": 13645497,
          "id_pacto": 377,
          "id_partido": 130,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jose_antonio_salvador_gonzalez_pizarro",
          "id_candidato_servel": 7337534,
          "id_pacto": 377,
          "id_partido": 45,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "liliana_ivania_gonzalez_cortes",
          "id_candidato_servel": 18183011,
          "id_pacto": 377,
          "id_partido": 45,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2508,
          "resultados": [
            {
              "id_candidato": "nalto_espinoza_hurtado",
              "id_candidato_servel": 6273728,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_solar_barrios",
              "id_candidato_servel": 7166120,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_salvador_gonzalez_pizarro",
              "id_candidato_servel": 7337534,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "doris_nerta_navarro_figueroa",
              "id_candidato_servel": 8577508,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sindy_tessa_gonzalez_salini",
              "id_candidato_servel": 9542426,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_montoya_mayorga",
              "id_candidato_servel": 10298243,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_cristian_mardones_gallardo",
              "id_candidato_servel": 10952965,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_cangana_loyola",
              "id_candidato_servel": 11721751,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_enrique_moraga_mena",
              "id_candidato_servel": 13014404,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tammy_soledad_verdugo_reyes",
              "id_candidato_servel": 13289217,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "johana_cristina_rivera_tejerina",
              "id_candidato_servel": 13645497,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "katherine_lopez_rivera",
              "id_candidato_servel": 14109173,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricio_maldonado_lavado",
              "id_candidato_servel": 14499183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_encina_munoz",
              "id_candidato_servel": 15085033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_castro_araya",
              "id_candidato_servel": 16203260,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_pomareda_echeverria",
              "id_candidato_servel": 16245075,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "freddy_vinales_vinales",
              "id_candidato_servel": 16924700,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liliana_ivania_gonzalez_cortes",
              "id_candidato_servel": 18183011,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "siomara_vanessa_molina_flores",
              "id_candidato_servel": 19952161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_andres_alvarez_tapia",
              "id_candidato_servel": 20817869,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2509,
          "resultados": [
            {
              "id_candidato": "nalto_espinoza_hurtado",
              "id_candidato_servel": 6273728,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_solar_barrios",
              "id_candidato_servel": 7166120,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_salvador_gonzalez_pizarro",
              "id_candidato_servel": 7337534,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "doris_nerta_navarro_figueroa",
              "id_candidato_servel": 8577508,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sindy_tessa_gonzalez_salini",
              "id_candidato_servel": 9542426,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_montoya_mayorga",
              "id_candidato_servel": 10298243,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_cristian_mardones_gallardo",
              "id_candidato_servel": 10952965,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_cangana_loyola",
              "id_candidato_servel": 11721751,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_enrique_moraga_mena",
              "id_candidato_servel": 13014404,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tammy_soledad_verdugo_reyes",
              "id_candidato_servel": 13289217,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "johana_cristina_rivera_tejerina",
              "id_candidato_servel": 13645497,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "katherine_lopez_rivera",
              "id_candidato_servel": 14109173,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricio_maldonado_lavado",
              "id_candidato_servel": 14499183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_encina_munoz",
              "id_candidato_servel": 15085033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_castro_araya",
              "id_candidato_servel": 16203260,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_pomareda_echeverria",
              "id_candidato_servel": 16245075,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "freddy_vinales_vinales",
              "id_candidato_servel": 16924700,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liliana_ivania_gonzalez_cortes",
              "id_candidato_servel": 18183011,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "siomara_vanessa_molina_flores",
              "id_candidato_servel": 19952161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_andres_alvarez_tapia",
              "id_candidato_servel": 20817869,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2510,
          "resultados": [
            {
              "id_candidato": "nalto_espinoza_hurtado",
              "id_candidato_servel": 6273728,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_solar_barrios",
              "id_candidato_servel": 7166120,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_salvador_gonzalez_pizarro",
              "id_candidato_servel": 7337534,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "doris_nerta_navarro_figueroa",
              "id_candidato_servel": 8577508,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sindy_tessa_gonzalez_salini",
              "id_candidato_servel": 9542426,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_montoya_mayorga",
              "id_candidato_servel": 10298243,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_cristian_mardones_gallardo",
              "id_candidato_servel": 10952965,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_cangana_loyola",
              "id_candidato_servel": 11721751,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_enrique_moraga_mena",
              "id_candidato_servel": 13014404,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tammy_soledad_verdugo_reyes",
              "id_candidato_servel": 13289217,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "johana_cristina_rivera_tejerina",
              "id_candidato_servel": 13645497,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "katherine_lopez_rivera",
              "id_candidato_servel": 14109173,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricio_maldonado_lavado",
              "id_candidato_servel": 14499183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_encina_munoz",
              "id_candidato_servel": 15085033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_castro_araya",
              "id_candidato_servel": 16203260,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_pomareda_echeverria",
              "id_candidato_servel": 16245075,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "freddy_vinales_vinales",
              "id_candidato_servel": 16924700,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liliana_ivania_gonzalez_cortes",
              "id_candidato_servel": 18183011,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "siomara_vanessa_molina_flores",
              "id_candidato_servel": 19952161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_andres_alvarez_tapia",
              "id_candidato_servel": 20817869,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2511,
          "resultados": [
            {
              "id_candidato": "nalto_espinoza_hurtado",
              "id_candidato_servel": 6273728,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_solar_barrios",
              "id_candidato_servel": 7166120,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_salvador_gonzalez_pizarro",
              "id_candidato_servel": 7337534,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "doris_nerta_navarro_figueroa",
              "id_candidato_servel": 8577508,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sindy_tessa_gonzalez_salini",
              "id_candidato_servel": 9542426,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_montoya_mayorga",
              "id_candidato_servel": 10298243,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_cristian_mardones_gallardo",
              "id_candidato_servel": 10952965,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_cangana_loyola",
              "id_candidato_servel": 11721751,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_enrique_moraga_mena",
              "id_candidato_servel": 13014404,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tammy_soledad_verdugo_reyes",
              "id_candidato_servel": 13289217,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "johana_cristina_rivera_tejerina",
              "id_candidato_servel": 13645497,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "katherine_lopez_rivera",
              "id_candidato_servel": 14109173,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricio_maldonado_lavado",
              "id_candidato_servel": 14499183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_encina_munoz",
              "id_candidato_servel": 15085033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_castro_araya",
              "id_candidato_servel": 16203260,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_pomareda_echeverria",
              "id_candidato_servel": 16245075,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "freddy_vinales_vinales",
              "id_candidato_servel": 16924700,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liliana_ivania_gonzalez_cortes",
              "id_candidato_servel": 18183011,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "siomara_vanessa_molina_flores",
              "id_candidato_servel": 19952161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_andres_alvarez_tapia",
              "id_candidato_servel": 20817869,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2512,
          "resultados": [
            {
              "id_candidato": "nalto_espinoza_hurtado",
              "id_candidato_servel": 6273728,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_solar_barrios",
              "id_candidato_servel": 7166120,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_salvador_gonzalez_pizarro",
              "id_candidato_servel": 7337534,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "doris_nerta_navarro_figueroa",
              "id_candidato_servel": 8577508,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sindy_tessa_gonzalez_salini",
              "id_candidato_servel": 9542426,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_montoya_mayorga",
              "id_candidato_servel": 10298243,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_cristian_mardones_gallardo",
              "id_candidato_servel": 10952965,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_cangana_loyola",
              "id_candidato_servel": 11721751,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_enrique_moraga_mena",
              "id_candidato_servel": 13014404,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tammy_soledad_verdugo_reyes",
              "id_candidato_servel": 13289217,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "johana_cristina_rivera_tejerina",
              "id_candidato_servel": 13645497,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "katherine_lopez_rivera",
              "id_candidato_servel": 14109173,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricio_maldonado_lavado",
              "id_candidato_servel": 14499183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_encina_munoz",
              "id_candidato_servel": 15085033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_castro_araya",
              "id_candidato_servel": 16203260,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_pomareda_echeverria",
              "id_candidato_servel": 16245075,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "freddy_vinales_vinales",
              "id_candidato_servel": 16924700,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liliana_ivania_gonzalez_cortes",
              "id_candidato_servel": 18183011,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "siomara_vanessa_molina_flores",
              "id_candidato_servel": 19952161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_andres_alvarez_tapia",
              "id_candidato_servel": 20817869,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2513,
          "resultados": [
            {
              "id_candidato": "nalto_espinoza_hurtado",
              "id_candidato_servel": 6273728,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_solar_barrios",
              "id_candidato_servel": 7166120,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_salvador_gonzalez_pizarro",
              "id_candidato_servel": 7337534,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "doris_nerta_navarro_figueroa",
              "id_candidato_servel": 8577508,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sindy_tessa_gonzalez_salini",
              "id_candidato_servel": 9542426,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_montoya_mayorga",
              "id_candidato_servel": 10298243,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_cristian_mardones_gallardo",
              "id_candidato_servel": 10952965,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_cangana_loyola",
              "id_candidato_servel": 11721751,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_enrique_moraga_mena",
              "id_candidato_servel": 13014404,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tammy_soledad_verdugo_reyes",
              "id_candidato_servel": 13289217,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "johana_cristina_rivera_tejerina",
              "id_candidato_servel": 13645497,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "katherine_lopez_rivera",
              "id_candidato_servel": 14109173,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricio_maldonado_lavado",
              "id_candidato_servel": 14499183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_encina_munoz",
              "id_candidato_servel": 15085033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_castro_araya",
              "id_candidato_servel": 16203260,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_pomareda_echeverria",
              "id_candidato_servel": 16245075,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "freddy_vinales_vinales",
              "id_candidato_servel": 16924700,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liliana_ivania_gonzalez_cortes",
              "id_candidato_servel": 18183011,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "siomara_vanessa_molina_flores",
              "id_candidato_servel": 19952161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_andres_alvarez_tapia",
              "id_candidato_servel": 20817869,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2514,
          "resultados": [
            {
              "id_candidato": "nalto_espinoza_hurtado",
              "id_candidato_servel": 6273728,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_solar_barrios",
              "id_candidato_servel": 7166120,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_salvador_gonzalez_pizarro",
              "id_candidato_servel": 7337534,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "doris_nerta_navarro_figueroa",
              "id_candidato_servel": 8577508,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sindy_tessa_gonzalez_salini",
              "id_candidato_servel": 9542426,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_montoya_mayorga",
              "id_candidato_servel": 10298243,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_cristian_mardones_gallardo",
              "id_candidato_servel": 10952965,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_cangana_loyola",
              "id_candidato_servel": 11721751,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_enrique_moraga_mena",
              "id_candidato_servel": 13014404,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tammy_soledad_verdugo_reyes",
              "id_candidato_servel": 13289217,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "johana_cristina_rivera_tejerina",
              "id_candidato_servel": 13645497,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "katherine_lopez_rivera",
              "id_candidato_servel": 14109173,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricio_maldonado_lavado",
              "id_candidato_servel": 14499183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_encina_munoz",
              "id_candidato_servel": 15085033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_castro_araya",
              "id_candidato_servel": 16203260,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_pomareda_echeverria",
              "id_candidato_servel": 16245075,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "freddy_vinales_vinales",
              "id_candidato_servel": 16924700,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liliana_ivania_gonzalez_cortes",
              "id_candidato_servel": 18183011,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "siomara_vanessa_molina_flores",
              "id_candidato_servel": 19952161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_andres_alvarez_tapia",
              "id_candidato_servel": 20817869,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2515,
          "resultados": [
            {
              "id_candidato": "nalto_espinoza_hurtado",
              "id_candidato_servel": 6273728,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_solar_barrios",
              "id_candidato_servel": 7166120,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_salvador_gonzalez_pizarro",
              "id_candidato_servel": 7337534,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "doris_nerta_navarro_figueroa",
              "id_candidato_servel": 8577508,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sindy_tessa_gonzalez_salini",
              "id_candidato_servel": 9542426,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_montoya_mayorga",
              "id_candidato_servel": 10298243,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_cristian_mardones_gallardo",
              "id_candidato_servel": 10952965,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_cangana_loyola",
              "id_candidato_servel": 11721751,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_enrique_moraga_mena",
              "id_candidato_servel": 13014404,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tammy_soledad_verdugo_reyes",
              "id_candidato_servel": 13289217,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "johana_cristina_rivera_tejerina",
              "id_candidato_servel": 13645497,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "katherine_lopez_rivera",
              "id_candidato_servel": 14109173,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricio_maldonado_lavado",
              "id_candidato_servel": 14499183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_encina_munoz",
              "id_candidato_servel": 15085033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_castro_araya",
              "id_candidato_servel": 16203260,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_pomareda_echeverria",
              "id_candidato_servel": 16245075,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "freddy_vinales_vinales",
              "id_candidato_servel": 16924700,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liliana_ivania_gonzalez_cortes",
              "id_candidato_servel": 18183011,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "siomara_vanessa_molina_flores",
              "id_candidato_servel": 19952161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_andres_alvarez_tapia",
              "id_candidato_servel": 20817869,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2516,
          "resultados": [
            {
              "id_candidato": "nalto_espinoza_hurtado",
              "id_candidato_servel": 6273728,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_solar_barrios",
              "id_candidato_servel": 7166120,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_salvador_gonzalez_pizarro",
              "id_candidato_servel": 7337534,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "doris_nerta_navarro_figueroa",
              "id_candidato_servel": 8577508,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sindy_tessa_gonzalez_salini",
              "id_candidato_servel": 9542426,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_montoya_mayorga",
              "id_candidato_servel": 10298243,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_cristian_mardones_gallardo",
              "id_candidato_servel": 10952965,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_cangana_loyola",
              "id_candidato_servel": 11721751,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_enrique_moraga_mena",
              "id_candidato_servel": 13014404,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tammy_soledad_verdugo_reyes",
              "id_candidato_servel": 13289217,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "johana_cristina_rivera_tejerina",
              "id_candidato_servel": 13645497,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "katherine_lopez_rivera",
              "id_candidato_servel": 14109173,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricio_maldonado_lavado",
              "id_candidato_servel": 14499183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_encina_munoz",
              "id_candidato_servel": 15085033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_castro_araya",
              "id_candidato_servel": 16203260,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_pomareda_echeverria",
              "id_candidato_servel": 16245075,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "freddy_vinales_vinales",
              "id_candidato_servel": 16924700,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liliana_ivania_gonzalez_cortes",
              "id_candidato_servel": 18183011,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "siomara_vanessa_molina_flores",
              "id_candidato_servel": 19952161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_andres_alvarez_tapia",
              "id_candidato_servel": 20817869,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "4",
      "resultados": [
        {
          "id_candidato": "carolina_de_los_angeles_cisternas_cepeda",
          "id_candidato_servel": 15028221,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "nora_luisa_vinas_godoy",
          "id_candidato_servel": 7921245,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jessica_alejandra_liquitay_martinez",
          "id_candidato_servel": 17195164,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "daniel_franco_patricio_flores_salinas",
          "id_candidato_servel": 17492607,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jair_ariel_jofre_henriquez",
          "id_candidato_servel": 17302195,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "nelson_del_transito_lopez_lopez",
          "id_candidato_servel": 7221693,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "veronica_teresa_garrido_briceno",
          "id_candidato_servel": 10609419,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "raul_araya_zepeda",
          "id_candidato_servel": 18445058,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "maria_paz_miranda_catalano",
          "id_candidato_servel": 13873240,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "giovanni_calderon_bassi",
          "id_candidato_servel": 11862663,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "yoris_rojas_vlastelica",
          "id_candidato_servel": 5175640,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "vittorio_ghiglino_bianchi",
          "id_candidato_servel": 16559282,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "kenssel_miguel_rojas_castro",
          "id_candidato_servel": 15610993,
          "id_pacto": 377,
          "id_partido": 6,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "yorka_elisabeth_quinteros_perez",
          "id_candidato_servel": 14397114,
          "id_pacto": 377,
          "id_partido": 45,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "marcela_alexandra_araya_sepulveda",
          "id_candidato_servel": 12940592,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "ricardo_nunez_munoz",
          "id_candidato_servel": 4102104,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "paul_alexander_sfeir_rubio",
          "id_candidato_servel": 6622672,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "sebastian_simon_vega",
          "id_candidato_servel": 11724787,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "fresia_maria_sepulveda_hanckes",
          "id_candidato_servel": 7134978,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "patricia_del_carmen_hurtado_loyola",
          "id_candidato_servel": 11333630,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2517,
          "resultados": [
            {
              "id_candidato": "ricardo_nunez_munoz",
              "id_candidato_servel": 4102104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yoris_rojas_vlastelica",
              "id_candidato_servel": 5175640,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paul_alexander_sfeir_rubio",
              "id_candidato_servel": 6622672,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fresia_maria_sepulveda_hanckes",
              "id_candidato_servel": 7134978,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_del_transito_lopez_lopez",
              "id_candidato_servel": 7221693,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nora_luisa_vinas_godoy",
              "id_candidato_servel": 7921245,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_teresa_garrido_briceno",
              "id_candidato_servel": 10609419,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_del_carmen_hurtado_loyola",
              "id_candidato_servel": 11333630,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_simon_vega",
              "id_candidato_servel": 11724787,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "giovanni_calderon_bassi",
              "id_candidato_servel": 11862663,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_alexandra_araya_sepulveda",
              "id_candidato_servel": 12940592,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_paz_miranda_catalano",
              "id_candidato_servel": 13873240,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yorka_elisabeth_quinteros_perez",
              "id_candidato_servel": 14397114,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_de_los_angeles_cisternas_cepeda",
              "id_candidato_servel": 15028221,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kenssel_miguel_rojas_castro",
              "id_candidato_servel": 15610993,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "vittorio_ghiglino_bianchi",
              "id_candidato_servel": 16559282,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_alejandra_liquitay_martinez",
              "id_candidato_servel": 17195164,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jair_ariel_jofre_henriquez",
              "id_candidato_servel": 17302195,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_franco_patricio_flores_salinas",
              "id_candidato_servel": 17492607,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_araya_zepeda",
              "id_candidato_servel": 18445058,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2518,
          "resultados": [
            {
              "id_candidato": "ricardo_nunez_munoz",
              "id_candidato_servel": 4102104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yoris_rojas_vlastelica",
              "id_candidato_servel": 5175640,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paul_alexander_sfeir_rubio",
              "id_candidato_servel": 6622672,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fresia_maria_sepulveda_hanckes",
              "id_candidato_servel": 7134978,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_del_transito_lopez_lopez",
              "id_candidato_servel": 7221693,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nora_luisa_vinas_godoy",
              "id_candidato_servel": 7921245,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_teresa_garrido_briceno",
              "id_candidato_servel": 10609419,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_del_carmen_hurtado_loyola",
              "id_candidato_servel": 11333630,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_simon_vega",
              "id_candidato_servel": 11724787,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "giovanni_calderon_bassi",
              "id_candidato_servel": 11862663,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_alexandra_araya_sepulveda",
              "id_candidato_servel": 12940592,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_paz_miranda_catalano",
              "id_candidato_servel": 13873240,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yorka_elisabeth_quinteros_perez",
              "id_candidato_servel": 14397114,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_de_los_angeles_cisternas_cepeda",
              "id_candidato_servel": 15028221,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kenssel_miguel_rojas_castro",
              "id_candidato_servel": 15610993,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "vittorio_ghiglino_bianchi",
              "id_candidato_servel": 16559282,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_alejandra_liquitay_martinez",
              "id_candidato_servel": 17195164,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jair_ariel_jofre_henriquez",
              "id_candidato_servel": 17302195,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_franco_patricio_flores_salinas",
              "id_candidato_servel": 17492607,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_araya_zepeda",
              "id_candidato_servel": 18445058,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2519,
          "resultados": [
            {
              "id_candidato": "ricardo_nunez_munoz",
              "id_candidato_servel": 4102104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yoris_rojas_vlastelica",
              "id_candidato_servel": 5175640,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paul_alexander_sfeir_rubio",
              "id_candidato_servel": 6622672,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fresia_maria_sepulveda_hanckes",
              "id_candidato_servel": 7134978,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_del_transito_lopez_lopez",
              "id_candidato_servel": 7221693,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nora_luisa_vinas_godoy",
              "id_candidato_servel": 7921245,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_teresa_garrido_briceno",
              "id_candidato_servel": 10609419,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_del_carmen_hurtado_loyola",
              "id_candidato_servel": 11333630,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_simon_vega",
              "id_candidato_servel": 11724787,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "giovanni_calderon_bassi",
              "id_candidato_servel": 11862663,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_alexandra_araya_sepulveda",
              "id_candidato_servel": 12940592,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_paz_miranda_catalano",
              "id_candidato_servel": 13873240,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yorka_elisabeth_quinteros_perez",
              "id_candidato_servel": 14397114,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_de_los_angeles_cisternas_cepeda",
              "id_candidato_servel": 15028221,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kenssel_miguel_rojas_castro",
              "id_candidato_servel": 15610993,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "vittorio_ghiglino_bianchi",
              "id_candidato_servel": 16559282,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_alejandra_liquitay_martinez",
              "id_candidato_servel": 17195164,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jair_ariel_jofre_henriquez",
              "id_candidato_servel": 17302195,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_franco_patricio_flores_salinas",
              "id_candidato_servel": 17492607,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_araya_zepeda",
              "id_candidato_servel": 18445058,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2520,
          "resultados": [
            {
              "id_candidato": "ricardo_nunez_munoz",
              "id_candidato_servel": 4102104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yoris_rojas_vlastelica",
              "id_candidato_servel": 5175640,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paul_alexander_sfeir_rubio",
              "id_candidato_servel": 6622672,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fresia_maria_sepulveda_hanckes",
              "id_candidato_servel": 7134978,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_del_transito_lopez_lopez",
              "id_candidato_servel": 7221693,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nora_luisa_vinas_godoy",
              "id_candidato_servel": 7921245,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_teresa_garrido_briceno",
              "id_candidato_servel": 10609419,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_del_carmen_hurtado_loyola",
              "id_candidato_servel": 11333630,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_simon_vega",
              "id_candidato_servel": 11724787,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "giovanni_calderon_bassi",
              "id_candidato_servel": 11862663,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_alexandra_araya_sepulveda",
              "id_candidato_servel": 12940592,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_paz_miranda_catalano",
              "id_candidato_servel": 13873240,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yorka_elisabeth_quinteros_perez",
              "id_candidato_servel": 14397114,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_de_los_angeles_cisternas_cepeda",
              "id_candidato_servel": 15028221,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kenssel_miguel_rojas_castro",
              "id_candidato_servel": 15610993,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "vittorio_ghiglino_bianchi",
              "id_candidato_servel": 16559282,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_alejandra_liquitay_martinez",
              "id_candidato_servel": 17195164,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jair_ariel_jofre_henriquez",
              "id_candidato_servel": 17302195,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_franco_patricio_flores_salinas",
              "id_candidato_servel": 17492607,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_araya_zepeda",
              "id_candidato_servel": 18445058,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2521,
          "resultados": [
            {
              "id_candidato": "ricardo_nunez_munoz",
              "id_candidato_servel": 4102104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yoris_rojas_vlastelica",
              "id_candidato_servel": 5175640,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paul_alexander_sfeir_rubio",
              "id_candidato_servel": 6622672,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fresia_maria_sepulveda_hanckes",
              "id_candidato_servel": 7134978,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_del_transito_lopez_lopez",
              "id_candidato_servel": 7221693,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nora_luisa_vinas_godoy",
              "id_candidato_servel": 7921245,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_teresa_garrido_briceno",
              "id_candidato_servel": 10609419,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_del_carmen_hurtado_loyola",
              "id_candidato_servel": 11333630,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_simon_vega",
              "id_candidato_servel": 11724787,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "giovanni_calderon_bassi",
              "id_candidato_servel": 11862663,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_alexandra_araya_sepulveda",
              "id_candidato_servel": 12940592,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_paz_miranda_catalano",
              "id_candidato_servel": 13873240,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yorka_elisabeth_quinteros_perez",
              "id_candidato_servel": 14397114,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_de_los_angeles_cisternas_cepeda",
              "id_candidato_servel": 15028221,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kenssel_miguel_rojas_castro",
              "id_candidato_servel": 15610993,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "vittorio_ghiglino_bianchi",
              "id_candidato_servel": 16559282,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_alejandra_liquitay_martinez",
              "id_candidato_servel": 17195164,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jair_ariel_jofre_henriquez",
              "id_candidato_servel": 17302195,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_franco_patricio_flores_salinas",
              "id_candidato_servel": 17492607,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_araya_zepeda",
              "id_candidato_servel": 18445058,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2522,
          "resultados": [
            {
              "id_candidato": "ricardo_nunez_munoz",
              "id_candidato_servel": 4102104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yoris_rojas_vlastelica",
              "id_candidato_servel": 5175640,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paul_alexander_sfeir_rubio",
              "id_candidato_servel": 6622672,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fresia_maria_sepulveda_hanckes",
              "id_candidato_servel": 7134978,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_del_transito_lopez_lopez",
              "id_candidato_servel": 7221693,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nora_luisa_vinas_godoy",
              "id_candidato_servel": 7921245,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_teresa_garrido_briceno",
              "id_candidato_servel": 10609419,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_del_carmen_hurtado_loyola",
              "id_candidato_servel": 11333630,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_simon_vega",
              "id_candidato_servel": 11724787,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "giovanni_calderon_bassi",
              "id_candidato_servel": 11862663,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_alexandra_araya_sepulveda",
              "id_candidato_servel": 12940592,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_paz_miranda_catalano",
              "id_candidato_servel": 13873240,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yorka_elisabeth_quinteros_perez",
              "id_candidato_servel": 14397114,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_de_los_angeles_cisternas_cepeda",
              "id_candidato_servel": 15028221,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kenssel_miguel_rojas_castro",
              "id_candidato_servel": 15610993,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "vittorio_ghiglino_bianchi",
              "id_candidato_servel": 16559282,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_alejandra_liquitay_martinez",
              "id_candidato_servel": 17195164,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jair_ariel_jofre_henriquez",
              "id_candidato_servel": 17302195,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_franco_patricio_flores_salinas",
              "id_candidato_servel": 17492607,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_araya_zepeda",
              "id_candidato_servel": 18445058,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2523,
          "resultados": [
            {
              "id_candidato": "ricardo_nunez_munoz",
              "id_candidato_servel": 4102104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yoris_rojas_vlastelica",
              "id_candidato_servel": 5175640,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paul_alexander_sfeir_rubio",
              "id_candidato_servel": 6622672,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fresia_maria_sepulveda_hanckes",
              "id_candidato_servel": 7134978,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_del_transito_lopez_lopez",
              "id_candidato_servel": 7221693,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nora_luisa_vinas_godoy",
              "id_candidato_servel": 7921245,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_teresa_garrido_briceno",
              "id_candidato_servel": 10609419,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_del_carmen_hurtado_loyola",
              "id_candidato_servel": 11333630,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_simon_vega",
              "id_candidato_servel": 11724787,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "giovanni_calderon_bassi",
              "id_candidato_servel": 11862663,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_alexandra_araya_sepulveda",
              "id_candidato_servel": 12940592,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_paz_miranda_catalano",
              "id_candidato_servel": 13873240,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yorka_elisabeth_quinteros_perez",
              "id_candidato_servel": 14397114,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_de_los_angeles_cisternas_cepeda",
              "id_candidato_servel": 15028221,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kenssel_miguel_rojas_castro",
              "id_candidato_servel": 15610993,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "vittorio_ghiglino_bianchi",
              "id_candidato_servel": 16559282,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_alejandra_liquitay_martinez",
              "id_candidato_servel": 17195164,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jair_ariel_jofre_henriquez",
              "id_candidato_servel": 17302195,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_franco_patricio_flores_salinas",
              "id_candidato_servel": 17492607,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_araya_zepeda",
              "id_candidato_servel": 18445058,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2524,
          "resultados": [
            {
              "id_candidato": "ricardo_nunez_munoz",
              "id_candidato_servel": 4102104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yoris_rojas_vlastelica",
              "id_candidato_servel": 5175640,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paul_alexander_sfeir_rubio",
              "id_candidato_servel": 6622672,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fresia_maria_sepulveda_hanckes",
              "id_candidato_servel": 7134978,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_del_transito_lopez_lopez",
              "id_candidato_servel": 7221693,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nora_luisa_vinas_godoy",
              "id_candidato_servel": 7921245,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_teresa_garrido_briceno",
              "id_candidato_servel": 10609419,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_del_carmen_hurtado_loyola",
              "id_candidato_servel": 11333630,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_simon_vega",
              "id_candidato_servel": 11724787,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "giovanni_calderon_bassi",
              "id_candidato_servel": 11862663,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_alexandra_araya_sepulveda",
              "id_candidato_servel": 12940592,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_paz_miranda_catalano",
              "id_candidato_servel": 13873240,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yorka_elisabeth_quinteros_perez",
              "id_candidato_servel": 14397114,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_de_los_angeles_cisternas_cepeda",
              "id_candidato_servel": 15028221,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kenssel_miguel_rojas_castro",
              "id_candidato_servel": 15610993,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "vittorio_ghiglino_bianchi",
              "id_candidato_servel": 16559282,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_alejandra_liquitay_martinez",
              "id_candidato_servel": 17195164,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jair_ariel_jofre_henriquez",
              "id_candidato_servel": 17302195,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_franco_patricio_flores_salinas",
              "id_candidato_servel": 17492607,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_araya_zepeda",
              "id_candidato_servel": 18445058,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2525,
          "resultados": [
            {
              "id_candidato": "ricardo_nunez_munoz",
              "id_candidato_servel": 4102104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yoris_rojas_vlastelica",
              "id_candidato_servel": 5175640,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paul_alexander_sfeir_rubio",
              "id_candidato_servel": 6622672,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fresia_maria_sepulveda_hanckes",
              "id_candidato_servel": 7134978,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_del_transito_lopez_lopez",
              "id_candidato_servel": 7221693,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nora_luisa_vinas_godoy",
              "id_candidato_servel": 7921245,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_teresa_garrido_briceno",
              "id_candidato_servel": 10609419,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_del_carmen_hurtado_loyola",
              "id_candidato_servel": 11333630,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_simon_vega",
              "id_candidato_servel": 11724787,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "giovanni_calderon_bassi",
              "id_candidato_servel": 11862663,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcela_alexandra_araya_sepulveda",
              "id_candidato_servel": 12940592,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_paz_miranda_catalano",
              "id_candidato_servel": 13873240,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yorka_elisabeth_quinteros_perez",
              "id_candidato_servel": 14397114,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_de_los_angeles_cisternas_cepeda",
              "id_candidato_servel": 15028221,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kenssel_miguel_rojas_castro",
              "id_candidato_servel": 15610993,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "vittorio_ghiglino_bianchi",
              "id_candidato_servel": 16559282,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_alejandra_liquitay_martinez",
              "id_candidato_servel": 17195164,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jair_ariel_jofre_henriquez",
              "id_candidato_servel": 17302195,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_franco_patricio_flores_salinas",
              "id_candidato_servel": 17492607,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_araya_zepeda",
              "id_candidato_servel": 18445058,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "5",
      "resultados": [
        {
          "id_candidato": "jacqueline_andrea_milla_ortiz",
          "id_candidato_servel": 14005883,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "susana_collao_nunez",
          "id_candidato_servel": 12219704,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "andres_eduardo_guerra_vega",
          "id_candidato_servel": 13330031,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "hector_rodolfo_rosas_bustos",
          "id_candidato_servel": 8005140,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "manuel_alejandro_contreras_olivares",
          "id_candidato_servel": 13330025,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "lilibeth_yuvixi_huerta_cortes",
          "id_candidato_servel": 17655691,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jorge_insunza_gregorio_de_las_heras",
          "id_candidato_servel": 9980104,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "tomas_enrique_alvarado_zepeda",
          "id_candidato_servel": 4678791,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "alejandra_elena_vivanco_reyes",
          "id_candidato_servel": 10673960,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "sergio_hernan_pino_vergara",
          "id_candidato_servel": 9330515,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "gloria_yolanda_paredes_diaz",
          "id_candidato_servel": 9727794,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "maria_teresita_prouvay_cornejo",
          "id_candidato_servel": 9884617,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "ana_maria_ahumada_gallardo",
          "id_candidato_servel": 13533486,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jorge_villar_gutierrez",
          "id_candidato_servel": 12096351,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "gonzalo_pinochet_abarca",
          "id_candidato_servel": 19077132,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "ivon_guerra_aguilera",
          "id_candidato_servel": 8879813,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carlos_galleguillos_carvajal",
          "id_candidato_servel": 13177657,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "camila_nidia_sabando_vega",
          "id_candidato_servel": 16944809,
          "id_pacto": 377,
          "id_partido": 149,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "fernando_antonio_viveros_reyes",
          "id_candidato_servel": 14062522,
          "id_pacto": 377,
          "id_partido": 6,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "valeria_patricia_chacana_alarcon",
          "id_candidato_servel": 19772148,
          "id_pacto": 377,
          "id_partido": 6,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2526,
          "resultados": [
            {
              "id_candidato": "tomas_enrique_alvarado_zepeda",
              "id_candidato_servel": 4678791,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_rodolfo_rosas_bustos",
              "id_candidato_servel": 8005140,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivon_guerra_aguilera",
              "id_candidato_servel": 8879813,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_hernan_pino_vergara",
              "id_candidato_servel": 9330515,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_yolanda_paredes_diaz",
              "id_candidato_servel": 9727794,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_teresita_prouvay_cornejo",
              "id_candidato_servel": 9884617,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_insunza_gregorio_de_las_heras",
              "id_candidato_servel": 9980104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandra_elena_vivanco_reyes",
              "id_candidato_servel": 10673960,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_villar_gutierrez",
              "id_candidato_servel": 12096351,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_collao_nunez",
              "id_candidato_servel": 12219704,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_galleguillos_carvajal",
              "id_candidato_servel": 13177657,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_alejandro_contreras_olivares",
              "id_candidato_servel": 13330025,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_eduardo_guerra_vega",
              "id_candidato_servel": 13330031,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ana_maria_ahumada_gallardo",
              "id_candidato_servel": 13533486,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_andrea_milla_ortiz",
              "id_candidato_servel": 14005883,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_antonio_viveros_reyes",
              "id_candidato_servel": 14062522,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_nidia_sabando_vega",
              "id_candidato_servel": 16944809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lilibeth_yuvixi_huerta_cortes",
              "id_candidato_servel": 17655691,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_pinochet_abarca",
              "id_candidato_servel": 19077132,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_patricia_chacana_alarcon",
              "id_candidato_servel": 19772148,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2527,
          "resultados": [
            {
              "id_candidato": "tomas_enrique_alvarado_zepeda",
              "id_candidato_servel": 4678791,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_rodolfo_rosas_bustos",
              "id_candidato_servel": 8005140,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivon_guerra_aguilera",
              "id_candidato_servel": 8879813,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_hernan_pino_vergara",
              "id_candidato_servel": 9330515,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_yolanda_paredes_diaz",
              "id_candidato_servel": 9727794,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_teresita_prouvay_cornejo",
              "id_candidato_servel": 9884617,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_insunza_gregorio_de_las_heras",
              "id_candidato_servel": 9980104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandra_elena_vivanco_reyes",
              "id_candidato_servel": 10673960,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_villar_gutierrez",
              "id_candidato_servel": 12096351,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_collao_nunez",
              "id_candidato_servel": 12219704,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_galleguillos_carvajal",
              "id_candidato_servel": 13177657,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_alejandro_contreras_olivares",
              "id_candidato_servel": 13330025,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_eduardo_guerra_vega",
              "id_candidato_servel": 13330031,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ana_maria_ahumada_gallardo",
              "id_candidato_servel": 13533486,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_andrea_milla_ortiz",
              "id_candidato_servel": 14005883,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_antonio_viveros_reyes",
              "id_candidato_servel": 14062522,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_nidia_sabando_vega",
              "id_candidato_servel": 16944809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lilibeth_yuvixi_huerta_cortes",
              "id_candidato_servel": 17655691,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_pinochet_abarca",
              "id_candidato_servel": 19077132,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_patricia_chacana_alarcon",
              "id_candidato_servel": 19772148,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2528,
          "resultados": [
            {
              "id_candidato": "tomas_enrique_alvarado_zepeda",
              "id_candidato_servel": 4678791,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_rodolfo_rosas_bustos",
              "id_candidato_servel": 8005140,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivon_guerra_aguilera",
              "id_candidato_servel": 8879813,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_hernan_pino_vergara",
              "id_candidato_servel": 9330515,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_yolanda_paredes_diaz",
              "id_candidato_servel": 9727794,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_teresita_prouvay_cornejo",
              "id_candidato_servel": 9884617,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_insunza_gregorio_de_las_heras",
              "id_candidato_servel": 9980104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandra_elena_vivanco_reyes",
              "id_candidato_servel": 10673960,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_villar_gutierrez",
              "id_candidato_servel": 12096351,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_collao_nunez",
              "id_candidato_servel": 12219704,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_galleguillos_carvajal",
              "id_candidato_servel": 13177657,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_alejandro_contreras_olivares",
              "id_candidato_servel": 13330025,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_eduardo_guerra_vega",
              "id_candidato_servel": 13330031,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ana_maria_ahumada_gallardo",
              "id_candidato_servel": 13533486,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_andrea_milla_ortiz",
              "id_candidato_servel": 14005883,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_antonio_viveros_reyes",
              "id_candidato_servel": 14062522,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_nidia_sabando_vega",
              "id_candidato_servel": 16944809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lilibeth_yuvixi_huerta_cortes",
              "id_candidato_servel": 17655691,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_pinochet_abarca",
              "id_candidato_servel": 19077132,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_patricia_chacana_alarcon",
              "id_candidato_servel": 19772148,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2529,
          "resultados": [
            {
              "id_candidato": "tomas_enrique_alvarado_zepeda",
              "id_candidato_servel": 4678791,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_rodolfo_rosas_bustos",
              "id_candidato_servel": 8005140,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivon_guerra_aguilera",
              "id_candidato_servel": 8879813,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_hernan_pino_vergara",
              "id_candidato_servel": 9330515,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_yolanda_paredes_diaz",
              "id_candidato_servel": 9727794,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_teresita_prouvay_cornejo",
              "id_candidato_servel": 9884617,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_insunza_gregorio_de_las_heras",
              "id_candidato_servel": 9980104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandra_elena_vivanco_reyes",
              "id_candidato_servel": 10673960,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_villar_gutierrez",
              "id_candidato_servel": 12096351,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_collao_nunez",
              "id_candidato_servel": 12219704,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_galleguillos_carvajal",
              "id_candidato_servel": 13177657,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_alejandro_contreras_olivares",
              "id_candidato_servel": 13330025,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_eduardo_guerra_vega",
              "id_candidato_servel": 13330031,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ana_maria_ahumada_gallardo",
              "id_candidato_servel": 13533486,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_andrea_milla_ortiz",
              "id_candidato_servel": 14005883,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_antonio_viveros_reyes",
              "id_candidato_servel": 14062522,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_nidia_sabando_vega",
              "id_candidato_servel": 16944809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lilibeth_yuvixi_huerta_cortes",
              "id_candidato_servel": 17655691,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_pinochet_abarca",
              "id_candidato_servel": 19077132,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_patricia_chacana_alarcon",
              "id_candidato_servel": 19772148,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2530,
          "resultados": [
            {
              "id_candidato": "tomas_enrique_alvarado_zepeda",
              "id_candidato_servel": 4678791,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_rodolfo_rosas_bustos",
              "id_candidato_servel": 8005140,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivon_guerra_aguilera",
              "id_candidato_servel": 8879813,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_hernan_pino_vergara",
              "id_candidato_servel": 9330515,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_yolanda_paredes_diaz",
              "id_candidato_servel": 9727794,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_teresita_prouvay_cornejo",
              "id_candidato_servel": 9884617,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_insunza_gregorio_de_las_heras",
              "id_candidato_servel": 9980104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandra_elena_vivanco_reyes",
              "id_candidato_servel": 10673960,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_villar_gutierrez",
              "id_candidato_servel": 12096351,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_collao_nunez",
              "id_candidato_servel": 12219704,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_galleguillos_carvajal",
              "id_candidato_servel": 13177657,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_alejandro_contreras_olivares",
              "id_candidato_servel": 13330025,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_eduardo_guerra_vega",
              "id_candidato_servel": 13330031,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ana_maria_ahumada_gallardo",
              "id_candidato_servel": 13533486,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_andrea_milla_ortiz",
              "id_candidato_servel": 14005883,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_antonio_viveros_reyes",
              "id_candidato_servel": 14062522,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_nidia_sabando_vega",
              "id_candidato_servel": 16944809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lilibeth_yuvixi_huerta_cortes",
              "id_candidato_servel": 17655691,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_pinochet_abarca",
              "id_candidato_servel": 19077132,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_patricia_chacana_alarcon",
              "id_candidato_servel": 19772148,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2531,
          "resultados": [
            {
              "id_candidato": "tomas_enrique_alvarado_zepeda",
              "id_candidato_servel": 4678791,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_rodolfo_rosas_bustos",
              "id_candidato_servel": 8005140,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivon_guerra_aguilera",
              "id_candidato_servel": 8879813,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_hernan_pino_vergara",
              "id_candidato_servel": 9330515,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_yolanda_paredes_diaz",
              "id_candidato_servel": 9727794,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_teresita_prouvay_cornejo",
              "id_candidato_servel": 9884617,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_insunza_gregorio_de_las_heras",
              "id_candidato_servel": 9980104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandra_elena_vivanco_reyes",
              "id_candidato_servel": 10673960,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_villar_gutierrez",
              "id_candidato_servel": 12096351,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_collao_nunez",
              "id_candidato_servel": 12219704,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_galleguillos_carvajal",
              "id_candidato_servel": 13177657,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_alejandro_contreras_olivares",
              "id_candidato_servel": 13330025,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_eduardo_guerra_vega",
              "id_candidato_servel": 13330031,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ana_maria_ahumada_gallardo",
              "id_candidato_servel": 13533486,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_andrea_milla_ortiz",
              "id_candidato_servel": 14005883,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_antonio_viveros_reyes",
              "id_candidato_servel": 14062522,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_nidia_sabando_vega",
              "id_candidato_servel": 16944809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lilibeth_yuvixi_huerta_cortes",
              "id_candidato_servel": 17655691,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_pinochet_abarca",
              "id_candidato_servel": 19077132,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_patricia_chacana_alarcon",
              "id_candidato_servel": 19772148,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2532,
          "resultados": [
            {
              "id_candidato": "tomas_enrique_alvarado_zepeda",
              "id_candidato_servel": 4678791,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_rodolfo_rosas_bustos",
              "id_candidato_servel": 8005140,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivon_guerra_aguilera",
              "id_candidato_servel": 8879813,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_hernan_pino_vergara",
              "id_candidato_servel": 9330515,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_yolanda_paredes_diaz",
              "id_candidato_servel": 9727794,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_teresita_prouvay_cornejo",
              "id_candidato_servel": 9884617,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_insunza_gregorio_de_las_heras",
              "id_candidato_servel": 9980104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandra_elena_vivanco_reyes",
              "id_candidato_servel": 10673960,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_villar_gutierrez",
              "id_candidato_servel": 12096351,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_collao_nunez",
              "id_candidato_servel": 12219704,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_galleguillos_carvajal",
              "id_candidato_servel": 13177657,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_alejandro_contreras_olivares",
              "id_candidato_servel": 13330025,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_eduardo_guerra_vega",
              "id_candidato_servel": 13330031,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ana_maria_ahumada_gallardo",
              "id_candidato_servel": 13533486,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_andrea_milla_ortiz",
              "id_candidato_servel": 14005883,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_antonio_viveros_reyes",
              "id_candidato_servel": 14062522,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_nidia_sabando_vega",
              "id_candidato_servel": 16944809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lilibeth_yuvixi_huerta_cortes",
              "id_candidato_servel": 17655691,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_pinochet_abarca",
              "id_candidato_servel": 19077132,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_patricia_chacana_alarcon",
              "id_candidato_servel": 19772148,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2533,
          "resultados": [
            {
              "id_candidato": "tomas_enrique_alvarado_zepeda",
              "id_candidato_servel": 4678791,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_rodolfo_rosas_bustos",
              "id_candidato_servel": 8005140,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivon_guerra_aguilera",
              "id_candidato_servel": 8879813,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_hernan_pino_vergara",
              "id_candidato_servel": 9330515,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_yolanda_paredes_diaz",
              "id_candidato_servel": 9727794,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_teresita_prouvay_cornejo",
              "id_candidato_servel": 9884617,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_insunza_gregorio_de_las_heras",
              "id_candidato_servel": 9980104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandra_elena_vivanco_reyes",
              "id_candidato_servel": 10673960,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_villar_gutierrez",
              "id_candidato_servel": 12096351,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_collao_nunez",
              "id_candidato_servel": 12219704,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_galleguillos_carvajal",
              "id_candidato_servel": 13177657,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_alejandro_contreras_olivares",
              "id_candidato_servel": 13330025,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_eduardo_guerra_vega",
              "id_candidato_servel": 13330031,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ana_maria_ahumada_gallardo",
              "id_candidato_servel": 13533486,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_andrea_milla_ortiz",
              "id_candidato_servel": 14005883,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_antonio_viveros_reyes",
              "id_candidato_servel": 14062522,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_nidia_sabando_vega",
              "id_candidato_servel": 16944809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lilibeth_yuvixi_huerta_cortes",
              "id_candidato_servel": 17655691,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_pinochet_abarca",
              "id_candidato_servel": 19077132,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_patricia_chacana_alarcon",
              "id_candidato_servel": 19772148,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2534,
          "resultados": [
            {
              "id_candidato": "tomas_enrique_alvarado_zepeda",
              "id_candidato_servel": 4678791,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_rodolfo_rosas_bustos",
              "id_candidato_servel": 8005140,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivon_guerra_aguilera",
              "id_candidato_servel": 8879813,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_hernan_pino_vergara",
              "id_candidato_servel": 9330515,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_yolanda_paredes_diaz",
              "id_candidato_servel": 9727794,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_teresita_prouvay_cornejo",
              "id_candidato_servel": 9884617,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_insunza_gregorio_de_las_heras",
              "id_candidato_servel": 9980104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandra_elena_vivanco_reyes",
              "id_candidato_servel": 10673960,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_villar_gutierrez",
              "id_candidato_servel": 12096351,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_collao_nunez",
              "id_candidato_servel": 12219704,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_galleguillos_carvajal",
              "id_candidato_servel": 13177657,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_alejandro_contreras_olivares",
              "id_candidato_servel": 13330025,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_eduardo_guerra_vega",
              "id_candidato_servel": 13330031,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ana_maria_ahumada_gallardo",
              "id_candidato_servel": 13533486,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_andrea_milla_ortiz",
              "id_candidato_servel": 14005883,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_antonio_viveros_reyes",
              "id_candidato_servel": 14062522,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_nidia_sabando_vega",
              "id_candidato_servel": 16944809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lilibeth_yuvixi_huerta_cortes",
              "id_candidato_servel": 17655691,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_pinochet_abarca",
              "id_candidato_servel": 19077132,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_patricia_chacana_alarcon",
              "id_candidato_servel": 19772148,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2535,
          "resultados": [
            {
              "id_candidato": "tomas_enrique_alvarado_zepeda",
              "id_candidato_servel": 4678791,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_rodolfo_rosas_bustos",
              "id_candidato_servel": 8005140,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivon_guerra_aguilera",
              "id_candidato_servel": 8879813,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_hernan_pino_vergara",
              "id_candidato_servel": 9330515,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_yolanda_paredes_diaz",
              "id_candidato_servel": 9727794,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_teresita_prouvay_cornejo",
              "id_candidato_servel": 9884617,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_insunza_gregorio_de_las_heras",
              "id_candidato_servel": 9980104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandra_elena_vivanco_reyes",
              "id_candidato_servel": 10673960,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_villar_gutierrez",
              "id_candidato_servel": 12096351,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_collao_nunez",
              "id_candidato_servel": 12219704,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_galleguillos_carvajal",
              "id_candidato_servel": 13177657,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_alejandro_contreras_olivares",
              "id_candidato_servel": 13330025,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_eduardo_guerra_vega",
              "id_candidato_servel": 13330031,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ana_maria_ahumada_gallardo",
              "id_candidato_servel": 13533486,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_andrea_milla_ortiz",
              "id_candidato_servel": 14005883,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_antonio_viveros_reyes",
              "id_candidato_servel": 14062522,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_nidia_sabando_vega",
              "id_candidato_servel": 16944809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lilibeth_yuvixi_huerta_cortes",
              "id_candidato_servel": 17655691,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_pinochet_abarca",
              "id_candidato_servel": 19077132,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_patricia_chacana_alarcon",
              "id_candidato_servel": 19772148,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2536,
          "resultados": [
            {
              "id_candidato": "tomas_enrique_alvarado_zepeda",
              "id_candidato_servel": 4678791,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_rodolfo_rosas_bustos",
              "id_candidato_servel": 8005140,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivon_guerra_aguilera",
              "id_candidato_servel": 8879813,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_hernan_pino_vergara",
              "id_candidato_servel": 9330515,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_yolanda_paredes_diaz",
              "id_candidato_servel": 9727794,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_teresita_prouvay_cornejo",
              "id_candidato_servel": 9884617,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_insunza_gregorio_de_las_heras",
              "id_candidato_servel": 9980104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandra_elena_vivanco_reyes",
              "id_candidato_servel": 10673960,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_villar_gutierrez",
              "id_candidato_servel": 12096351,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_collao_nunez",
              "id_candidato_servel": 12219704,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_galleguillos_carvajal",
              "id_candidato_servel": 13177657,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_alejandro_contreras_olivares",
              "id_candidato_servel": 13330025,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_eduardo_guerra_vega",
              "id_candidato_servel": 13330031,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ana_maria_ahumada_gallardo",
              "id_candidato_servel": 13533486,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_andrea_milla_ortiz",
              "id_candidato_servel": 14005883,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_antonio_viveros_reyes",
              "id_candidato_servel": 14062522,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_nidia_sabando_vega",
              "id_candidato_servel": 16944809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lilibeth_yuvixi_huerta_cortes",
              "id_candidato_servel": 17655691,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_pinochet_abarca",
              "id_candidato_servel": 19077132,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_patricia_chacana_alarcon",
              "id_candidato_servel": 19772148,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2537,
          "resultados": [
            {
              "id_candidato": "tomas_enrique_alvarado_zepeda",
              "id_candidato_servel": 4678791,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_rodolfo_rosas_bustos",
              "id_candidato_servel": 8005140,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivon_guerra_aguilera",
              "id_candidato_servel": 8879813,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_hernan_pino_vergara",
              "id_candidato_servel": 9330515,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_yolanda_paredes_diaz",
              "id_candidato_servel": 9727794,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_teresita_prouvay_cornejo",
              "id_candidato_servel": 9884617,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_insunza_gregorio_de_las_heras",
              "id_candidato_servel": 9980104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandra_elena_vivanco_reyes",
              "id_candidato_servel": 10673960,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_villar_gutierrez",
              "id_candidato_servel": 12096351,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_collao_nunez",
              "id_candidato_servel": 12219704,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_galleguillos_carvajal",
              "id_candidato_servel": 13177657,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_alejandro_contreras_olivares",
              "id_candidato_servel": 13330025,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_eduardo_guerra_vega",
              "id_candidato_servel": 13330031,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ana_maria_ahumada_gallardo",
              "id_candidato_servel": 13533486,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_andrea_milla_ortiz",
              "id_candidato_servel": 14005883,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_antonio_viveros_reyes",
              "id_candidato_servel": 14062522,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_nidia_sabando_vega",
              "id_candidato_servel": 16944809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lilibeth_yuvixi_huerta_cortes",
              "id_candidato_servel": 17655691,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_pinochet_abarca",
              "id_candidato_servel": 19077132,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_patricia_chacana_alarcon",
              "id_candidato_servel": 19772148,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2538,
          "resultados": [
            {
              "id_candidato": "tomas_enrique_alvarado_zepeda",
              "id_candidato_servel": 4678791,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_rodolfo_rosas_bustos",
              "id_candidato_servel": 8005140,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivon_guerra_aguilera",
              "id_candidato_servel": 8879813,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_hernan_pino_vergara",
              "id_candidato_servel": 9330515,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_yolanda_paredes_diaz",
              "id_candidato_servel": 9727794,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_teresita_prouvay_cornejo",
              "id_candidato_servel": 9884617,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_insunza_gregorio_de_las_heras",
              "id_candidato_servel": 9980104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandra_elena_vivanco_reyes",
              "id_candidato_servel": 10673960,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_villar_gutierrez",
              "id_candidato_servel": 12096351,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_collao_nunez",
              "id_candidato_servel": 12219704,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_galleguillos_carvajal",
              "id_candidato_servel": 13177657,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_alejandro_contreras_olivares",
              "id_candidato_servel": 13330025,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_eduardo_guerra_vega",
              "id_candidato_servel": 13330031,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ana_maria_ahumada_gallardo",
              "id_candidato_servel": 13533486,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_andrea_milla_ortiz",
              "id_candidato_servel": 14005883,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_antonio_viveros_reyes",
              "id_candidato_servel": 14062522,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_nidia_sabando_vega",
              "id_candidato_servel": 16944809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lilibeth_yuvixi_huerta_cortes",
              "id_candidato_servel": 17655691,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_pinochet_abarca",
              "id_candidato_servel": 19077132,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_patricia_chacana_alarcon",
              "id_candidato_servel": 19772148,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2539,
          "resultados": [
            {
              "id_candidato": "tomas_enrique_alvarado_zepeda",
              "id_candidato_servel": 4678791,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_rodolfo_rosas_bustos",
              "id_candidato_servel": 8005140,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivon_guerra_aguilera",
              "id_candidato_servel": 8879813,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_hernan_pino_vergara",
              "id_candidato_servel": 9330515,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_yolanda_paredes_diaz",
              "id_candidato_servel": 9727794,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_teresita_prouvay_cornejo",
              "id_candidato_servel": 9884617,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_insunza_gregorio_de_las_heras",
              "id_candidato_servel": 9980104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandra_elena_vivanco_reyes",
              "id_candidato_servel": 10673960,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_villar_gutierrez",
              "id_candidato_servel": 12096351,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_collao_nunez",
              "id_candidato_servel": 12219704,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_galleguillos_carvajal",
              "id_candidato_servel": 13177657,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_alejandro_contreras_olivares",
              "id_candidato_servel": 13330025,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_eduardo_guerra_vega",
              "id_candidato_servel": 13330031,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ana_maria_ahumada_gallardo",
              "id_candidato_servel": 13533486,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_andrea_milla_ortiz",
              "id_candidato_servel": 14005883,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_antonio_viveros_reyes",
              "id_candidato_servel": 14062522,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_nidia_sabando_vega",
              "id_candidato_servel": 16944809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lilibeth_yuvixi_huerta_cortes",
              "id_candidato_servel": 17655691,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_pinochet_abarca",
              "id_candidato_servel": 19077132,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_patricia_chacana_alarcon",
              "id_candidato_servel": 19772148,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2540,
          "resultados": [
            {
              "id_candidato": "tomas_enrique_alvarado_zepeda",
              "id_candidato_servel": 4678791,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_rodolfo_rosas_bustos",
              "id_candidato_servel": 8005140,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivon_guerra_aguilera",
              "id_candidato_servel": 8879813,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sergio_hernan_pino_vergara",
              "id_candidato_servel": 9330515,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_yolanda_paredes_diaz",
              "id_candidato_servel": 9727794,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_teresita_prouvay_cornejo",
              "id_candidato_servel": 9884617,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_insunza_gregorio_de_las_heras",
              "id_candidato_servel": 9980104,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandra_elena_vivanco_reyes",
              "id_candidato_servel": 10673960,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_villar_gutierrez",
              "id_candidato_servel": 12096351,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_collao_nunez",
              "id_candidato_servel": 12219704,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_galleguillos_carvajal",
              "id_candidato_servel": 13177657,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_alejandro_contreras_olivares",
              "id_candidato_servel": 13330025,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_eduardo_guerra_vega",
              "id_candidato_servel": 13330031,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ana_maria_ahumada_gallardo",
              "id_candidato_servel": 13533486,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_andrea_milla_ortiz",
              "id_candidato_servel": 14005883,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_antonio_viveros_reyes",
              "id_candidato_servel": 14062522,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_nidia_sabando_vega",
              "id_candidato_servel": 16944809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lilibeth_yuvixi_huerta_cortes",
              "id_candidato_servel": 17655691,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_pinochet_abarca",
              "id_candidato_servel": 19077132,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_patricia_chacana_alarcon",
              "id_candidato_servel": 19772148,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "6",
      "resultados": [
        {
          "id_candidato": "marco_antonio_nunez_lozano",
          "id_candidato_servel": 8500066,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carla_natalia_allendes_soza",
          "id_candidato_servel": 16105082,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "raimundo_jesus_palamara_stewart",
          "id_candidato_servel": 16361211,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "aldo_valle_acevedo",
          "id_candidato_servel": 6642777,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "leslie_briones_rojo",
          "id_candidato_servel": 14138006,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jazmin_murillo_jorquera",
          "id_candidato_servel": 18272557,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "christian_andres_inostroza_cabrera",
          "id_candidato_servel": 16332679,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "darma_odette_lopez_torres",
          "id_candidato_servel": 7008999,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "manuel_armando_tobar_leiva",
          "id_candidato_servel": 6687951,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "pedro_rodolfo_schwedelbach_puga",
          "id_candidato_servel": 15541513,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
          "id_candidato_servel": 8576244,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "antonio_barchiesi_chavez",
          "id_candidato_servel": 17355645,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "tatiana_paola_bernal_parra",
          "id_candidato_servel": 14447560,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "maria_de_los_angeles_lopez_porfiri",
          "id_candidato_servel": 16686002,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "marcelo_schilling_rodriguez",
          "id_candidato_servel": 5344795,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "gonzalo_andres_vega_moreno",
          "id_candidato_servel": 13068925,
          "id_pacto": 377,
          "id_partido": 143,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carolina_patricia_fernandez_quezada",
          "id_candidato_servel": 13997900,
          "id_pacto": 377,
          "id_partido": 6,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "valeria_angelica_carcamo_vidal",
          "id_candidato_servel": 18282601,
          "id_pacto": 377,
          "id_partido": 45,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "maria_soledad_pardo_vergara",
          "id_candidato_servel": 16887738,
          "id_pacto": 377,
          "id_partido": 149,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "gonzalo_ibanez_santa_maria",
          "id_candidato_servel": 4386100,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "edmundo_eluchans_urenda",
          "id_candidato_servel": 4721073,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "viviana_nunez_carrasco",
          "id_candidato_servel": 16678544,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "gonzalo_yuseff_quiros",
          "id_candidato_servel": 9012679,
          "id_pacto": 379,
          "id_partido": 37,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "luigina_pruzzo_guerra",
          "id_candidato_servel": 13544441,
          "id_pacto": 379,
          "id_partido": 37,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2545,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2546,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2549,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2550,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2551,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2552,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2553,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2554,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2555,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2556,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2557,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2558,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2559,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2560,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2561,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2562,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2569,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2570,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2571,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2572,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2573,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2574,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2575,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2576,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2577,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2578,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2541,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2542,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2543,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2544,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2547,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2548,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2563,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2564,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2565,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2566,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2567,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2568,
          "resultados": [
            {
              "id_candidato": "gonzalo_ibanez_santa_maria",
              "id_candidato_servel": 4386100,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "edmundo_eluchans_urenda",
              "id_candidato_servel": 4721073,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_schilling_rodriguez",
              "id_candidato_servel": 5344795,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_valle_acevedo",
              "id_candidato_servel": 6642777,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_armando_tobar_leiva",
              "id_candidato_servel": 6687951,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "darma_odette_lopez_torres",
              "id_candidato_servel": 7008999,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marco_antonio_nunez_lozano",
              "id_candidato_servel": 8500066,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "chantal_robert_de_la_mahotiere_flottes",
              "id_candidato_servel": 8576244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_yuseff_quiros",
              "id_candidato_servel": 9012679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_andres_vega_moreno",
              "id_candidato_servel": 13068925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luigina_pruzzo_guerra",
              "id_candidato_servel": 13544441,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_patricia_fernandez_quezada",
              "id_candidato_servel": 13997900,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "leslie_briones_rojo",
              "id_candidato_servel": 14138006,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tatiana_paola_bernal_parra",
              "id_candidato_servel": 14447560,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_rodolfo_schwedelbach_puga",
              "id_candidato_servel": 15541513,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carla_natalia_allendes_soza",
              "id_candidato_servel": 16105082,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_andres_inostroza_cabrera",
              "id_candidato_servel": 16332679,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raimundo_jesus_palamara_stewart",
              "id_candidato_servel": 16361211,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_nunez_carrasco",
              "id_candidato_servel": 16678544,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_de_los_angeles_lopez_porfiri",
              "id_candidato_servel": 16686002,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_soledad_pardo_vergara",
              "id_candidato_servel": 16887738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "antonio_barchiesi_chavez",
              "id_candidato_servel": 17355645,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jazmin_murillo_jorquera",
              "id_candidato_servel": 18272557,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_angelica_carcamo_vidal",
              "id_candidato_servel": 18282601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "7",
      "resultados": [
        {
          "id_candidato": "elizabeth_rodriguez_sierra",
          "id_candidato_servel": 16244695,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "andres_jaime_palma_irarrazaval",
          "id_candidato_servel": 7040289,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "macarena_del_carmen_bravo_rojas",
          "id_candidato_servel": 18531341,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "yerko_antonio_ljubetic_godoy",
          "id_candidato_servel": 8077485,
          "id_pacto": 377,
          "id_partido": 149,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "gloria_hutt_hesse",
          "id_candidato_servel": 6069264,
          "id_pacto": 379,
          "id_partido": 37,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "gonzalo_german_inojosa_hernandez",
          "id_candidato_servel": 8680065,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "tamara_alejandra_ramirez_ramirez",
          "id_candidato_servel": 17952087,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
          "id_candidato_servel": 19039122,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carmen_gloria_gonzalez_burns",
          "id_candidato_servel": 11483597,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "mauricio_andres_pavez_galaz",
          "id_candidato_servel": 12892091,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carmen_victoria_frei_ruiztagle",
          "id_candidato_servel": 4107128,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "rodrigo_jose_chandia_soto",
          "id_candidato_servel": 10800928,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "andres_emilio_sepulveda_jimenez",
          "id_candidato_servel": 15342974,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "paz_suarez_briones",
          "id_candidato_servel": 14188439,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "natalia_piergentili_domenech",
          "id_candidato_servel": 10055396,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jorge_jose_ossandon_spoerer",
          "id_candidato_servel": 16095244,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "sylvia_del_carmen_bustos_aguirre",
          "id_candidato_servel": 12068971,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "ignacio_andres_dulger_castillo",
          "id_candidato_servel": 18173007,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "luis_silva_irarrazaval",
          "id_candidato_servel": 9024616,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "tabita_sarai_silva_leiva",
          "id_candidato_servel": 17590387,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "rodrigo_alfonso_rettig_vargas",
          "id_candidato_servel": 15382950,
          "id_pacto": 377,
          "id_partido": 137,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "sadi_melo_moya",
          "id_candidato_servel": 7077432,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "rocio_fernanda_donoso_pineda",
          "id_candidato_servel": 16470244,
          "id_pacto": 377,
          "id_partido": 45,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "camila_fernanda_miranda_medina",
          "id_candidato_servel": 17033397,
          "id_pacto": 377,
          "id_partido": 143,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "karen_viviana_araya_rojas",
          "id_candidato_servel": 13684095,
          "id_pacto": 377,
          "id_partido": 6,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jaime_ravinet_de_la_fuente",
          "id_candidato_servel": 4665925,
          "id_pacto": 379,
          "id_partido": 37,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "rodrigo_delgado_mocarquer",
          "id_candidato_servel": 8771203,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "maria_jose_puigrredon_figueroa",
          "id_candidato_servel": 16071849,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "eleonora_espinoza_hernandez",
          "id_candidato_servel": 13252861,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "bruno_baranda_ferran",
          "id_candidato_servel": 7563445,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2759,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2763,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2776,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2781,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2782,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2793,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2794,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2795,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2760,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2761,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2764,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2765,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2774,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2783,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2784,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2785,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2758,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2768,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2775,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2777,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2780,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2786,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2770,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2771,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2772,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2779,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2789,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2767,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2769,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2790,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2791,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2792,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2762,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2766,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2773,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2778,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2787,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2788,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2796,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2797,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2798,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2799,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2800,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2801,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2802,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2803,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2804,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2805,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2806,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2807,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2808,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2809,
          "resultados": [
            {
              "id_candidato": "carmen_victoria_frei_ruiztagle",
              "id_candidato_servel": 4107128,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jaime_ravinet_de_la_fuente",
              "id_candidato_servel": 4665925,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_hutt_hesse",
              "id_candidato_servel": 6069264,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_jaime_palma_irarrazaval",
              "id_candidato_servel": 7040289,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sadi_melo_moya",
              "id_candidato_servel": 7077432,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bruno_baranda_ferran",
              "id_candidato_servel": 7563445,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yerko_antonio_ljubetic_godoy",
              "id_candidato_servel": 8077485,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gonzalo_german_inojosa_hernandez",
              "id_candidato_servel": 8680065,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_delgado_mocarquer",
              "id_candidato_servel": 8771203,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_silva_irarrazaval",
              "id_candidato_servel": 9024616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "natalia_piergentili_domenech",
              "id_candidato_servel": 10055396,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_jose_chandia_soto",
              "id_candidato_servel": 10800928,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carmen_gloria_gonzalez_burns",
              "id_candidato_servel": 11483597,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sylvia_del_carmen_bustos_aguirre",
              "id_candidato_servel": 12068971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mauricio_andres_pavez_galaz",
              "id_candidato_servel": 12892091,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eleonora_espinoza_hernandez",
              "id_candidato_servel": 13252861,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "karen_viviana_araya_rojas",
              "id_candidato_servel": 13684095,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paz_suarez_briones",
              "id_candidato_servel": 14188439,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andres_emilio_sepulveda_jimenez",
              "id_candidato_servel": 15342974,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rodrigo_alfonso_rettig_vargas",
              "id_candidato_servel": 15382950,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_jose_puigrredon_figueroa",
              "id_candidato_servel": 16071849,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_jose_ossandon_spoerer",
              "id_candidato_servel": 16095244,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elizabeth_rodriguez_sierra",
              "id_candidato_servel": 16244695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_fernanda_donoso_pineda",
              "id_candidato_servel": 16470244,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_fernanda_miranda_medina",
              "id_candidato_servel": 17033397,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tabita_sarai_silva_leiva",
              "id_candidato_servel": 17590387,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_alejandra_ramirez_ramirez",
              "id_candidato_servel": 17952087,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_dulger_castillo",
              "id_candidato_servel": 18173007,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "macarena_del_carmen_bravo_rojas",
              "id_candidato_servel": 18531341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ramon_antonio_leonardo_huidobro_leiva",
              "id_candidato_servel": 19039122,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "8",
      "resultados": [
        {
          "id_candidato": "carol_aros_seguel",
          "id_candidato_servel": 15787782,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "marcia_isabel_barrera_cisternas",
          "id_candidato_servel": 12911092,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "elisa_amelia_salas_lopez",
          "id_candidato_servel": 10773416,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carlos_sebastian_guerra_morales",
          "id_candidato_servel": 16843356,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "susan_evelyn_gomez_pardo",
          "id_candidato_servel": 13033031,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "luis_felipe_lorenzini_clavel",
          "id_candidato_servel": 7212608,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "bernardo_francisco_zapata_abarca",
          "id_candidato_servel": 6651899,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "monica_maria_del_carmen_latorre_roldan",
          "id_candidato_servel": 11276885,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "pedro_andres_marchant_villanueva",
          "id_candidato_servel": 6101810,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "patricia_besa_tagle",
          "id_candidato_servel": 12232600,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "gabriel_dominguez_valdes",
          "id_candidato_servel": 17408591,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "sebastian_alberto_figueroa_melo",
          "id_candidato_servel": 15385619,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "valentin_matus_martinez",
          "id_candidato_servel": 20038517,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "maria_ignacia_castro_rojas",
          "id_candidato_servel": 11278401,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "juan_sutil_servoin",
          "id_candidato_servel": 8525872,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "ivonne_mangelsdorff_galeb",
          "id_candidato_servel": 12913235,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "miguel_littin_cucumides",
          "id_candidato_servel": 4384763,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "daniel_alfonso_olivares_vidal",
          "id_candidato_servel": 17335724,
          "id_pacto": 377,
          "id_partido": 149,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "raisa_tamara_martinez_munoz",
          "id_candidato_servel": 17139066,
          "id_pacto": 377,
          "id_partido": 6,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "dominica_leonor_guzman_arce",
          "id_candidato_servel": 13561003,
          "id_pacto": 377,
          "id_partido": 130,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2579,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2580,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2581,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2582,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2583,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2584,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2586,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2587,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2588,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2589,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2592,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2593,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2594,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2585,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2590,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2591,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2595,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2596,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2597,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2598,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2599,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2600,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2601,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2602,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2603,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2604,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2605,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2606,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2607,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2608,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2609,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2610,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2611,
          "resultados": [
            {
              "id_candidato": "miguel_littin_cucumides",
              "id_candidato_servel": 4384763,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_andres_marchant_villanueva",
              "id_candidato_servel": 6101810,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "bernardo_francisco_zapata_abarca",
              "id_candidato_servel": 6651899,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_felipe_lorenzini_clavel",
              "id_candidato_servel": 7212608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_sutil_servoin",
              "id_candidato_servel": 8525872,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elisa_amelia_salas_lopez",
              "id_candidato_servel": 10773416,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "monica_maria_del_carmen_latorre_roldan",
              "id_candidato_servel": 11276885,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_ignacia_castro_rojas",
              "id_candidato_servel": 11278401,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_besa_tagle",
              "id_candidato_servel": 12232600,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcia_isabel_barrera_cisternas",
              "id_candidato_servel": 12911092,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ivonne_mangelsdorff_galeb",
              "id_candidato_servel": 12913235,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susan_evelyn_gomez_pardo",
              "id_candidato_servel": 13033031,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dominica_leonor_guzman_arce",
              "id_candidato_servel": 13561003,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_alberto_figueroa_melo",
              "id_candidato_servel": 15385619,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carol_aros_seguel",
              "id_candidato_servel": 15787782,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_sebastian_guerra_morales",
              "id_candidato_servel": 16843356,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raisa_tamara_martinez_munoz",
              "id_candidato_servel": 17139066,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_alfonso_olivares_vidal",
              "id_candidato_servel": 17335724,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_dominguez_valdes",
              "id_candidato_servel": 17408591,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentin_matus_martinez",
              "id_candidato_servel": 20038517,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "9",
      "resultados": [
        {
          "id_candidato": "boris_humberto_chavez_zambrano",
          "id_candidato_servel": 9754223,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "maria_gatica_gajardo",
          "id_candidato_servel": 9480453,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "rocio_margarita_moya_romero",
          "id_candidato_servel": 17495971,
          "id_pacto": 377,
          "id_partido": 45,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "maria_claudia_jorquera_coria",
          "id_candidato_servel": 10483956,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carolina_alejandra_contreras_retamal",
          "id_candidato_servel": 15754384,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "susana_veronica_pacheco_marcos",
          "id_candidato_servel": 14348730,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "dina_catherine_castillo_castillo",
          "id_candidato_servel": 14200292,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "fabian_andres_rios_lara",
          "id_candidato_servel": 16837359,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jorge_enrique_rojas_carvajal",
          "id_candidato_servel": 14288560,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
          "id_candidato_servel": 15126874,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "miguel_rojas_soto",
          "id_candidato_servel": 19702708,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "segundo_andres_hojas_del_valle",
          "id_candidato_servel": 8087560,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "hilda_cecilia_toledo_fuentes",
          "id_candidato_servel": 4831889,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "ricardo_ortega_perrier",
          "id_candidato_servel": 6163989,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "greis_marisel_parada_rojas",
          "id_candidato_servel": 13205274,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "sebastian_henriquez_munoz",
          "id_candidato_servel": 17336793,
          "id_pacto": 377,
          "id_partido": 45,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "christian_suarez_crothers",
          "id_candidato_servel": 8158868,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "erna_marjorie_maldonado_casanova",
          "id_candidato_servel": 12522490,
          "id_pacto": 377,
          "id_partido": 6,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "constanza_andrea_pavez_andaur",
          "id_candidato_servel": 17469709,
          "id_pacto": 377,
          "id_partido": 149,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "manuel_arnoldo_amestica_gaete",
          "id_candidato_servel": 9433193,
          "id_pacto": 377,
          "id_partido": 130,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "mario_undurraga_castelblanco",
          "id_candidato_servel": 8363183,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
          "id_candidato_servel": 16001930,
          "id_pacto": 379,
          "id_partido": 37,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "fernanda_pinochet_olave",
          "id_candidato_servel": 13231889,
          "id_pacto": 379,
          "id_partido": 37,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "marlenne_duran_seguel",
          "id_candidato_servel": 13600685,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "luis_valentin_ferrada_valenzuela",
          "id_candidato_servel": 5093082,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "pablo_ignacio_verdugo_vergara",
          "id_candidato_servel": 16008078,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jacqueline_jara_avalos",
          "id_candidato_servel": 15989734,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "guillermo_ceroni_fuentes",
          "id_candidato_servel": 4388742,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2612,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2613,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2614,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2615,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2616,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2617,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2618,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2619,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2620,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2621,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2625,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2626,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2627,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2628,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2629,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2630,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2631,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2632,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2633,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2622,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2623,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2624,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2634,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2635,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2636,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2637,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2638,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2639,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2640,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2641,
          "resultados": [
            {
              "id_candidato": "guillermo_ceroni_fuentes",
              "id_candidato_servel": 4388742,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hilda_cecilia_toledo_fuentes",
              "id_candidato_servel": 4831889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_valentin_ferrada_valenzuela",
              "id_candidato_servel": 5093082,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ortega_perrier",
              "id_candidato_servel": 6163989,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "segundo_andres_hojas_del_valle",
              "id_candidato_servel": 8087560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_suarez_crothers",
              "id_candidato_servel": 8158868,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_undurraga_castelblanco",
              "id_candidato_servel": 8363183,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "manuel_arnoldo_amestica_gaete",
              "id_candidato_servel": 9433193,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_gatica_gajardo",
              "id_candidato_servel": 9480453,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "boris_humberto_chavez_zambrano",
              "id_candidato_servel": 9754223,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_claudia_jorquera_coria",
              "id_candidato_servel": 10483956,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_marjorie_maldonado_casanova",
              "id_candidato_servel": 12522490,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "greis_marisel_parada_rojas",
              "id_candidato_servel": 13205274,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernanda_pinochet_olave",
              "id_candidato_servel": 13231889,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marlenne_duran_seguel",
              "id_candidato_servel": 13600685,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "dina_catherine_castillo_castillo",
              "id_candidato_servel": 14200292,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_enrique_rojas_carvajal",
              "id_candidato_servel": 14288560,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "susana_veronica_pacheco_marcos",
              "id_candidato_servel": 14348730,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "viviana_de_las_mercedes_rodriguez_saavedra",
              "id_candidato_servel": 15126874,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_alejandra_contreras_retamal",
              "id_candidato_servel": 15754384,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jacqueline_jara_avalos",
              "id_candidato_servel": 15989734,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_fernando_daniel_gonzalez_herrera",
              "id_candidato_servel": 16001930,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_verdugo_vergara",
              "id_candidato_servel": 16008078,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fabian_andres_rios_lara",
              "id_candidato_servel": 16837359,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sebastian_henriquez_munoz",
              "id_candidato_servel": 17336793,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_andrea_pavez_andaur",
              "id_candidato_servel": 17469709,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rocio_margarita_moya_romero",
              "id_candidato_servel": 17495971,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_rojas_soto",
              "id_candidato_servel": 19702708,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "10",
      "resultados": [
        {
          "id_candidato": "astrid_stephanie_abarzua_bravo",
          "id_candidato_servel": 15657601,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "nataly_yanira_neira_montoya",
          "id_candidato_servel": 17913563,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "patricia_spoerer_price",
          "id_candidato_servel": 10980343,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "nelson_alexander_cares_ormeno",
          "id_candidato_servel": 15627805,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "mirtha_victoria_encina_ovalle",
          "id_candidato_servel": 17007833,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "hugo_antonio_soto_becerra",
          "id_candidato_servel": 9243488,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "cristian_daniel_san_martin_carrasco",
          "id_candidato_servel": 12086253,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "gabriel_alejandro_benelli_paredes",
          "id_candidato_servel": 15616382,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "rossana_enriquez_castillo",
          "id_candidato_servel": 10899219,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carlos_francisco_ordenes_gatica",
          "id_candidato_servel": 13143472,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "aldo_sanhueza_carrera",
          "id_candidato_servel": 18137981,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "claudia_polette_ortega_saez",
          "id_candidato_servel": 17592810,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jorge_ulloa_aguillon",
          "id_candidato_servel": 8226720,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "victoria_pincheira_poblete",
          "id_candidato_servel": 16983698,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "robert_contreras_reyes",
          "id_candidato_servel": 10254641,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "monica_troncoso_salinas",
          "id_candidato_servel": 5756427,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carolina_beatriz_martinez_ebner",
          "id_candidato_servel": 15593050,
          "id_pacto": 377,
          "id_partido": 137,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "cristian_eduardo_cartes_ruz",
          "id_candidato_servel": 12974034,
          "id_pacto": 377,
          "id_partido": 130,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "pablo_ignacio_cuevas_munoz",
          "id_candidato_servel": 16215470,
          "id_pacto": 377,
          "id_partido": 6,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "paloma_ignacia_zuniga_cerda",
          "id_candidato_servel": 17516540,
          "id_pacto": 377,
          "id_partido": 45,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2642,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2643,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2644,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2645,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2646,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2648,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2649,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2650,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2651,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2652,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2653,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2647,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2654,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2655,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2656,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2657,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2658,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2659,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2660,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2661,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2662,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2663,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2664,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2665,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2666,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2667,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2668,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2669,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2670,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2671,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2672,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2673,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2674,
          "resultados": [
            {
              "id_candidato": "monica_troncoso_salinas",
              "id_candidato_servel": 5756427,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_ulloa_aguillon",
              "id_candidato_servel": 8226720,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hugo_antonio_soto_becerra",
              "id_candidato_servel": 9243488,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_contreras_reyes",
              "id_candidato_servel": 10254641,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rossana_enriquez_castillo",
              "id_candidato_servel": 10899219,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_spoerer_price",
              "id_candidato_servel": 10980343,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_daniel_san_martin_carrasco",
              "id_candidato_servel": 12086253,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_eduardo_cartes_ruz",
              "id_candidato_servel": 12974034,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_francisco_ordenes_gatica",
              "id_candidato_servel": 13143472,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_beatriz_martinez_ebner",
              "id_candidato_servel": 15593050,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gabriel_alejandro_benelli_paredes",
              "id_candidato_servel": 15616382,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nelson_alexander_cares_ormeno",
              "id_candidato_servel": 15627805,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "astrid_stephanie_abarzua_bravo",
              "id_candidato_servel": 15657601,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_ignacio_cuevas_munoz",
              "id_candidato_servel": 16215470,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_pincheira_poblete",
              "id_candidato_servel": 16983698,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mirtha_victoria_encina_ovalle",
              "id_candidato_servel": 17007833,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paloma_ignacia_zuniga_cerda",
              "id_candidato_servel": 17516540,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_polette_ortega_saez",
              "id_candidato_servel": 17592810,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nataly_yanira_neira_montoya",
              "id_candidato_servel": 17913563,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_sanhueza_carrera",
              "id_candidato_servel": 18137981,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "11",
      "resultados": [
        {
          "id_candidato": "pedro_marcelo_bermedo_lillo",
          "id_candidato_servel": 12743015,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "kiria_gladys_antileo_mella",
          "id_candidato_servel": 12331341,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "mariela_andrea_fincheira_massardo",
          "id_candidato_servel": 15652835,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jose_antonio_jerez_burgos",
          "id_candidato_servel": 11591149,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "magdalena_traub_etchegoyen",
          "id_candidato_servel": 14166738,
          "id_pacto": 379,
          "id_partido": 37,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "roberto_andres_bascunan_saldias",
          "id_candidato_servel": 15214271,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "cesar_camilo_quijada_contreras",
          "id_candidato_servel": 17281207,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "flor_rossany_contreras_vivallo",
          "id_candidato_servel": 10915395,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "daniela_paz_medel_sanhueza",
          "id_candidato_servel": 15661905,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "constanza_anais_carvacho_escalona",
          "id_candidato_servel": 19379658,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "felipe_esteban_calfunao_varas",
          "id_candidato_servel": 17263186,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "miriam_paola_valdes_zuniga",
          "id_candidato_servel": 12527957,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "alfredo_vallejos_provoste",
          "id_candidato_servel": 9282652,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "pamela_alejandra_toloza_burgos",
          "id_candidato_servel": 15388153,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
          "id_candidato_servel": 9021531,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "martin_andres_kuschke_belandrino",
          "id_candidato_servel": 16367320,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "stefani_del_pilar_alarcon_herrera",
          "id_candidato_servel": 16595075,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "loreto_ester_campana_morales",
          "id_candidato_servel": 13319116,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "hector_urban_astete",
          "id_candidato_servel": 10457308,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "mario_garcia_westermeyer",
          "id_candidato_servel": 15550237,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "raul_allard_soto",
          "id_candidato_servel": 8196077,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "christian_roman_dulansky_araya",
          "id_candidato_servel": 11686898,
          "id_pacto": 377,
          "id_partido": 149,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "kinturay_carlina_melin_rapiman",
          "id_candidato_servel": 18720009,
          "id_pacto": 377,
          "id_partido": 45,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "erna_andrea_quijon_godoy",
          "id_candidato_servel": 12192925,
          "id_pacto": 377,
          "id_partido": 6,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
          "id_candidato_servel": 12030611,
          "id_pacto": 377,
          "id_partido": 130,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jose_luis_hidalgo_pino",
          "id_candidato_servel": 16317068,
          "id_pacto": 379,
          "id_partido": 37,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "german_becker_alvear",
          "id_candidato_servel": 7701180,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "solange_carmine_rojas",
          "id_candidato_servel": 7724817,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carolina_lagos_jofre",
          "id_candidato_servel": 12628019,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "arturo_phillips_dorr",
          "id_candidato_servel": 19244835,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jorge_alejandro_sepulveda_rosales",
          "id_candidato_servel": 17366053,
          "id_pacto": 382,
          "id_partido": 99,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2680,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2682,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2684,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2687,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2693,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2696,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2697,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2698,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2699,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2700,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2701,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2702,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2703,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2704,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2705,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2706,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2675,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2676,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2677,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2678,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2679,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2681,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2683,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2685,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2686,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2688,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2689,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2690,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2691,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2692,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2694,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2695,
          "resultados": [
            {
              "id_candidato": "german_becker_alvear",
              "id_candidato_servel": 7701180,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "solange_carmine_rojas",
              "id_candidato_servel": 7724817,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "raul_allard_soto",
              "id_candidato_servel": 8196077,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hugo_hiram_pacheco_schmidt",
              "id_candidato_servel": 9021531,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alfredo_vallejos_provoste",
              "id_candidato_servel": 9282652,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "hector_urban_astete",
              "id_candidato_servel": 10457308,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "flor_rossany_contreras_vivallo",
              "id_candidato_servel": 10915395,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_jerez_burgos",
              "id_candidato_servel": 11591149,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "christian_roman_dulansky_araya",
              "id_candidato_servel": 11686898,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gemita_del_pilar_alvarez_sepulveda",
              "id_candidato_servel": 12030611,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erna_andrea_quijon_godoy",
              "id_candidato_servel": 12192925,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kiria_gladys_antileo_mella",
              "id_candidato_servel": 12331341,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miriam_paola_valdes_zuniga",
              "id_candidato_servel": 12527957,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_lagos_jofre",
              "id_candidato_servel": 12628019,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_marcelo_bermedo_lillo",
              "id_candidato_servel": 12743015,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "loreto_ester_campana_morales",
              "id_candidato_servel": 13319116,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "magdalena_traub_etchegoyen",
              "id_candidato_servel": 14166738,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "roberto_andres_bascunan_saldias",
              "id_candidato_servel": 15214271,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pamela_alejandra_toloza_burgos",
              "id_candidato_servel": 15388153,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mario_garcia_westermeyer",
              "id_candidato_servel": 15550237,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "mariela_andrea_fincheira_massardo",
              "id_candidato_servel": 15652835,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniela_paz_medel_sanhueza",
              "id_candidato_servel": 15661905,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_luis_hidalgo_pino",
              "id_candidato_servel": 16317068,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "martin_andres_kuschke_belandrino",
              "id_candidato_servel": 16367320,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "stefani_del_pilar_alarcon_herrera",
              "id_candidato_servel": 16595075,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "felipe_esteban_calfunao_varas",
              "id_candidato_servel": 17263186,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cesar_camilo_quijada_contreras",
              "id_candidato_servel": 17281207,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_alejandro_sepulveda_rosales",
              "id_candidato_servel": 17366053,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "kinturay_carlina_melin_rapiman",
              "id_candidato_servel": 18720009,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "arturo_phillips_dorr",
              "id_candidato_servel": 19244835,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_anais_carvacho_escalona",
              "id_candidato_servel": 19379658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "12",
      "resultados": [
        {
          "id_candidato": "maria_sonia_aguilef_gallegos",
          "id_candidato_servel": 10219549,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "marila_loreto_barrientos_trivinos",
          "id_candidato_servel": 13817897,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "paola_francesca_claverol_martinez",
          "id_candidato_servel": 16096392,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "gustavo_eduardo_davila_sepulveda",
          "id_candidato_servel": 10836331,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "francisco_isidoro_henriquez_munoz",
          "id_candidato_servel": 15354219,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "emma_patricia_cifuentes_barrientos",
          "id_candidato_servel": 10486198,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "miguel_barriga_parra",
          "id_candidato_servel": 8897628,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "miguel_david_ramirez_carvajal",
          "id_candidato_servel": 5280504,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "madelin_yosette_jau_jaramillo",
          "id_candidato_servel": 16805952,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jorge_de_la_maza_schleyer",
          "id_candidato_servel": 10488532,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "daniel_andres_arzola_garrido",
          "id_candidato_servel": 15797290,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "patricia_liliana_ayora_cavour",
          "id_candidato_servel": 10982517,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carola_cabeza_fuentes",
          "id_candidato_servel": 14036888,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "pedro_lamas_gutierrez",
          "id_candidato_servel": 15734731,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "lorena_gallardo_cardenas",
          "id_candidato_servel": 18913745,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jose_antonio_urrutia_riesco",
          "id_candidato_servel": 7011719,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "valeria_amanda_ochoa_hinrichsen",
          "id_candidato_servel": 16805216,
          "id_pacto": 377,
          "id_partido": 149,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "oscar_eduardo_mendoza_uriarte",
          "id_candidato_servel": 8094886,
          "id_pacto": 377,
          "id_partido": 6,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "nancy_silva_guerrero",
          "id_candidato_servel": 7143674,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "alejandro_kohler_vargas",
          "id_candidato_servel": 6530889,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2810,
          "resultados": [
            {
              "id_candidato": "miguel_david_ramirez_carvajal",
              "id_candidato_servel": 5280504,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandro_kohler_vargas",
              "id_candidato_servel": 6530889,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_urrutia_riesco",
              "id_candidato_servel": 7011719,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_silva_guerrero",
              "id_candidato_servel": 7143674,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "oscar_eduardo_mendoza_uriarte",
              "id_candidato_servel": 8094886,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_barriga_parra",
              "id_candidato_servel": 8897628,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_sonia_aguilef_gallegos",
              "id_candidato_servel": 10219549,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "emma_patricia_cifuentes_barrientos",
              "id_candidato_servel": 10486198,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_de_la_maza_schleyer",
              "id_candidato_servel": 10488532,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gustavo_eduardo_davila_sepulveda",
              "id_candidato_servel": 10836331,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_liliana_ayora_cavour",
              "id_candidato_servel": 10982517,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marila_loreto_barrientos_trivinos",
              "id_candidato_servel": 13817897,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carola_cabeza_fuentes",
              "id_candidato_servel": 14036888,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisco_isidoro_henriquez_munoz",
              "id_candidato_servel": 15354219,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_lamas_gutierrez",
              "id_candidato_servel": 15734731,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_andres_arzola_garrido",
              "id_candidato_servel": 15797290,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_francesca_claverol_martinez",
              "id_candidato_servel": 16096392,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_amanda_ochoa_hinrichsen",
              "id_candidato_servel": 16805216,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "madelin_yosette_jau_jaramillo",
              "id_candidato_servel": 16805952,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_gallardo_cardenas",
              "id_candidato_servel": 18913745,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2811,
          "resultados": [
            {
              "id_candidato": "miguel_david_ramirez_carvajal",
              "id_candidato_servel": 5280504,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandro_kohler_vargas",
              "id_candidato_servel": 6530889,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_urrutia_riesco",
              "id_candidato_servel": 7011719,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_silva_guerrero",
              "id_candidato_servel": 7143674,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "oscar_eduardo_mendoza_uriarte",
              "id_candidato_servel": 8094886,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_barriga_parra",
              "id_candidato_servel": 8897628,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_sonia_aguilef_gallegos",
              "id_candidato_servel": 10219549,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "emma_patricia_cifuentes_barrientos",
              "id_candidato_servel": 10486198,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_de_la_maza_schleyer",
              "id_candidato_servel": 10488532,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gustavo_eduardo_davila_sepulveda",
              "id_candidato_servel": 10836331,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_liliana_ayora_cavour",
              "id_candidato_servel": 10982517,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marila_loreto_barrientos_trivinos",
              "id_candidato_servel": 13817897,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carola_cabeza_fuentes",
              "id_candidato_servel": 14036888,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisco_isidoro_henriquez_munoz",
              "id_candidato_servel": 15354219,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_lamas_gutierrez",
              "id_candidato_servel": 15734731,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_andres_arzola_garrido",
              "id_candidato_servel": 15797290,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_francesca_claverol_martinez",
              "id_candidato_servel": 16096392,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_amanda_ochoa_hinrichsen",
              "id_candidato_servel": 16805216,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "madelin_yosette_jau_jaramillo",
              "id_candidato_servel": 16805952,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_gallardo_cardenas",
              "id_candidato_servel": 18913745,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2812,
          "resultados": [
            {
              "id_candidato": "miguel_david_ramirez_carvajal",
              "id_candidato_servel": 5280504,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandro_kohler_vargas",
              "id_candidato_servel": 6530889,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_urrutia_riesco",
              "id_candidato_servel": 7011719,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_silva_guerrero",
              "id_candidato_servel": 7143674,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "oscar_eduardo_mendoza_uriarte",
              "id_candidato_servel": 8094886,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_barriga_parra",
              "id_candidato_servel": 8897628,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_sonia_aguilef_gallegos",
              "id_candidato_servel": 10219549,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "emma_patricia_cifuentes_barrientos",
              "id_candidato_servel": 10486198,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_de_la_maza_schleyer",
              "id_candidato_servel": 10488532,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gustavo_eduardo_davila_sepulveda",
              "id_candidato_servel": 10836331,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_liliana_ayora_cavour",
              "id_candidato_servel": 10982517,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marila_loreto_barrientos_trivinos",
              "id_candidato_servel": 13817897,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carola_cabeza_fuentes",
              "id_candidato_servel": 14036888,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisco_isidoro_henriquez_munoz",
              "id_candidato_servel": 15354219,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_lamas_gutierrez",
              "id_candidato_servel": 15734731,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_andres_arzola_garrido",
              "id_candidato_servel": 15797290,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_francesca_claverol_martinez",
              "id_candidato_servel": 16096392,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_amanda_ochoa_hinrichsen",
              "id_candidato_servel": 16805216,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "madelin_yosette_jau_jaramillo",
              "id_candidato_servel": 16805952,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_gallardo_cardenas",
              "id_candidato_servel": 18913745,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2813,
          "resultados": [
            {
              "id_candidato": "miguel_david_ramirez_carvajal",
              "id_candidato_servel": 5280504,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandro_kohler_vargas",
              "id_candidato_servel": 6530889,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_urrutia_riesco",
              "id_candidato_servel": 7011719,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_silva_guerrero",
              "id_candidato_servel": 7143674,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "oscar_eduardo_mendoza_uriarte",
              "id_candidato_servel": 8094886,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_barriga_parra",
              "id_candidato_servel": 8897628,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_sonia_aguilef_gallegos",
              "id_candidato_servel": 10219549,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "emma_patricia_cifuentes_barrientos",
              "id_candidato_servel": 10486198,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_de_la_maza_schleyer",
              "id_candidato_servel": 10488532,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gustavo_eduardo_davila_sepulveda",
              "id_candidato_servel": 10836331,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_liliana_ayora_cavour",
              "id_candidato_servel": 10982517,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marila_loreto_barrientos_trivinos",
              "id_candidato_servel": 13817897,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carola_cabeza_fuentes",
              "id_candidato_servel": 14036888,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisco_isidoro_henriquez_munoz",
              "id_candidato_servel": 15354219,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_lamas_gutierrez",
              "id_candidato_servel": 15734731,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_andres_arzola_garrido",
              "id_candidato_servel": 15797290,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_francesca_claverol_martinez",
              "id_candidato_servel": 16096392,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_amanda_ochoa_hinrichsen",
              "id_candidato_servel": 16805216,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "madelin_yosette_jau_jaramillo",
              "id_candidato_servel": 16805952,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_gallardo_cardenas",
              "id_candidato_servel": 18913745,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2814,
          "resultados": [
            {
              "id_candidato": "miguel_david_ramirez_carvajal",
              "id_candidato_servel": 5280504,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandro_kohler_vargas",
              "id_candidato_servel": 6530889,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_urrutia_riesco",
              "id_candidato_servel": 7011719,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_silva_guerrero",
              "id_candidato_servel": 7143674,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "oscar_eduardo_mendoza_uriarte",
              "id_candidato_servel": 8094886,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_barriga_parra",
              "id_candidato_servel": 8897628,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_sonia_aguilef_gallegos",
              "id_candidato_servel": 10219549,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "emma_patricia_cifuentes_barrientos",
              "id_candidato_servel": 10486198,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_de_la_maza_schleyer",
              "id_candidato_servel": 10488532,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gustavo_eduardo_davila_sepulveda",
              "id_candidato_servel": 10836331,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_liliana_ayora_cavour",
              "id_candidato_servel": 10982517,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marila_loreto_barrientos_trivinos",
              "id_candidato_servel": 13817897,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carola_cabeza_fuentes",
              "id_candidato_servel": 14036888,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisco_isidoro_henriquez_munoz",
              "id_candidato_servel": 15354219,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_lamas_gutierrez",
              "id_candidato_servel": 15734731,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_andres_arzola_garrido",
              "id_candidato_servel": 15797290,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_francesca_claverol_martinez",
              "id_candidato_servel": 16096392,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_amanda_ochoa_hinrichsen",
              "id_candidato_servel": 16805216,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "madelin_yosette_jau_jaramillo",
              "id_candidato_servel": 16805952,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_gallardo_cardenas",
              "id_candidato_servel": 18913745,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2815,
          "resultados": [
            {
              "id_candidato": "miguel_david_ramirez_carvajal",
              "id_candidato_servel": 5280504,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandro_kohler_vargas",
              "id_candidato_servel": 6530889,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_urrutia_riesco",
              "id_candidato_servel": 7011719,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_silva_guerrero",
              "id_candidato_servel": 7143674,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "oscar_eduardo_mendoza_uriarte",
              "id_candidato_servel": 8094886,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_barriga_parra",
              "id_candidato_servel": 8897628,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_sonia_aguilef_gallegos",
              "id_candidato_servel": 10219549,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "emma_patricia_cifuentes_barrientos",
              "id_candidato_servel": 10486198,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_de_la_maza_schleyer",
              "id_candidato_servel": 10488532,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gustavo_eduardo_davila_sepulveda",
              "id_candidato_servel": 10836331,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_liliana_ayora_cavour",
              "id_candidato_servel": 10982517,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marila_loreto_barrientos_trivinos",
              "id_candidato_servel": 13817897,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carola_cabeza_fuentes",
              "id_candidato_servel": 14036888,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisco_isidoro_henriquez_munoz",
              "id_candidato_servel": 15354219,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_lamas_gutierrez",
              "id_candidato_servel": 15734731,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_andres_arzola_garrido",
              "id_candidato_servel": 15797290,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_francesca_claverol_martinez",
              "id_candidato_servel": 16096392,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_amanda_ochoa_hinrichsen",
              "id_candidato_servel": 16805216,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "madelin_yosette_jau_jaramillo",
              "id_candidato_servel": 16805952,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_gallardo_cardenas",
              "id_candidato_servel": 18913745,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2816,
          "resultados": [
            {
              "id_candidato": "miguel_david_ramirez_carvajal",
              "id_candidato_servel": 5280504,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandro_kohler_vargas",
              "id_candidato_servel": 6530889,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_urrutia_riesco",
              "id_candidato_servel": 7011719,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_silva_guerrero",
              "id_candidato_servel": 7143674,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "oscar_eduardo_mendoza_uriarte",
              "id_candidato_servel": 8094886,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_barriga_parra",
              "id_candidato_servel": 8897628,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_sonia_aguilef_gallegos",
              "id_candidato_servel": 10219549,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "emma_patricia_cifuentes_barrientos",
              "id_candidato_servel": 10486198,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_de_la_maza_schleyer",
              "id_candidato_servel": 10488532,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gustavo_eduardo_davila_sepulveda",
              "id_candidato_servel": 10836331,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_liliana_ayora_cavour",
              "id_candidato_servel": 10982517,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marila_loreto_barrientos_trivinos",
              "id_candidato_servel": 13817897,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carola_cabeza_fuentes",
              "id_candidato_servel": 14036888,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisco_isidoro_henriquez_munoz",
              "id_candidato_servel": 15354219,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_lamas_gutierrez",
              "id_candidato_servel": 15734731,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_andres_arzola_garrido",
              "id_candidato_servel": 15797290,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_francesca_claverol_martinez",
              "id_candidato_servel": 16096392,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_amanda_ochoa_hinrichsen",
              "id_candidato_servel": 16805216,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "madelin_yosette_jau_jaramillo",
              "id_candidato_servel": 16805952,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_gallardo_cardenas",
              "id_candidato_servel": 18913745,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2817,
          "resultados": [
            {
              "id_candidato": "miguel_david_ramirez_carvajal",
              "id_candidato_servel": 5280504,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandro_kohler_vargas",
              "id_candidato_servel": 6530889,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_urrutia_riesco",
              "id_candidato_servel": 7011719,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_silva_guerrero",
              "id_candidato_servel": 7143674,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "oscar_eduardo_mendoza_uriarte",
              "id_candidato_servel": 8094886,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_barriga_parra",
              "id_candidato_servel": 8897628,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_sonia_aguilef_gallegos",
              "id_candidato_servel": 10219549,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "emma_patricia_cifuentes_barrientos",
              "id_candidato_servel": 10486198,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_de_la_maza_schleyer",
              "id_candidato_servel": 10488532,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gustavo_eduardo_davila_sepulveda",
              "id_candidato_servel": 10836331,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_liliana_ayora_cavour",
              "id_candidato_servel": 10982517,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marila_loreto_barrientos_trivinos",
              "id_candidato_servel": 13817897,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carola_cabeza_fuentes",
              "id_candidato_servel": 14036888,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisco_isidoro_henriquez_munoz",
              "id_candidato_servel": 15354219,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_lamas_gutierrez",
              "id_candidato_servel": 15734731,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_andres_arzola_garrido",
              "id_candidato_servel": 15797290,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_francesca_claverol_martinez",
              "id_candidato_servel": 16096392,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_amanda_ochoa_hinrichsen",
              "id_candidato_servel": 16805216,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "madelin_yosette_jau_jaramillo",
              "id_candidato_servel": 16805952,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_gallardo_cardenas",
              "id_candidato_servel": 18913745,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2818,
          "resultados": [
            {
              "id_candidato": "miguel_david_ramirez_carvajal",
              "id_candidato_servel": 5280504,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandro_kohler_vargas",
              "id_candidato_servel": 6530889,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_urrutia_riesco",
              "id_candidato_servel": 7011719,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_silva_guerrero",
              "id_candidato_servel": 7143674,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "oscar_eduardo_mendoza_uriarte",
              "id_candidato_servel": 8094886,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_barriga_parra",
              "id_candidato_servel": 8897628,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_sonia_aguilef_gallegos",
              "id_candidato_servel": 10219549,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "emma_patricia_cifuentes_barrientos",
              "id_candidato_servel": 10486198,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_de_la_maza_schleyer",
              "id_candidato_servel": 10488532,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gustavo_eduardo_davila_sepulveda",
              "id_candidato_servel": 10836331,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_liliana_ayora_cavour",
              "id_candidato_servel": 10982517,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marila_loreto_barrientos_trivinos",
              "id_candidato_servel": 13817897,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carola_cabeza_fuentes",
              "id_candidato_servel": 14036888,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisco_isidoro_henriquez_munoz",
              "id_candidato_servel": 15354219,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_lamas_gutierrez",
              "id_candidato_servel": 15734731,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_andres_arzola_garrido",
              "id_candidato_servel": 15797290,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_francesca_claverol_martinez",
              "id_candidato_servel": 16096392,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_amanda_ochoa_hinrichsen",
              "id_candidato_servel": 16805216,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "madelin_yosette_jau_jaramillo",
              "id_candidato_servel": 16805952,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_gallardo_cardenas",
              "id_candidato_servel": 18913745,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2819,
          "resultados": [
            {
              "id_candidato": "miguel_david_ramirez_carvajal",
              "id_candidato_servel": 5280504,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandro_kohler_vargas",
              "id_candidato_servel": 6530889,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_urrutia_riesco",
              "id_candidato_servel": 7011719,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_silva_guerrero",
              "id_candidato_servel": 7143674,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "oscar_eduardo_mendoza_uriarte",
              "id_candidato_servel": 8094886,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_barriga_parra",
              "id_candidato_servel": 8897628,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_sonia_aguilef_gallegos",
              "id_candidato_servel": 10219549,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "emma_patricia_cifuentes_barrientos",
              "id_candidato_servel": 10486198,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_de_la_maza_schleyer",
              "id_candidato_servel": 10488532,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gustavo_eduardo_davila_sepulveda",
              "id_candidato_servel": 10836331,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_liliana_ayora_cavour",
              "id_candidato_servel": 10982517,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marila_loreto_barrientos_trivinos",
              "id_candidato_servel": 13817897,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carola_cabeza_fuentes",
              "id_candidato_servel": 14036888,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisco_isidoro_henriquez_munoz",
              "id_candidato_servel": 15354219,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_lamas_gutierrez",
              "id_candidato_servel": 15734731,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_andres_arzola_garrido",
              "id_candidato_servel": 15797290,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_francesca_claverol_martinez",
              "id_candidato_servel": 16096392,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_amanda_ochoa_hinrichsen",
              "id_candidato_servel": 16805216,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "madelin_yosette_jau_jaramillo",
              "id_candidato_servel": 16805952,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_gallardo_cardenas",
              "id_candidato_servel": 18913745,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2820,
          "resultados": [
            {
              "id_candidato": "miguel_david_ramirez_carvajal",
              "id_candidato_servel": 5280504,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandro_kohler_vargas",
              "id_candidato_servel": 6530889,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_urrutia_riesco",
              "id_candidato_servel": 7011719,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_silva_guerrero",
              "id_candidato_servel": 7143674,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "oscar_eduardo_mendoza_uriarte",
              "id_candidato_servel": 8094886,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_barriga_parra",
              "id_candidato_servel": 8897628,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_sonia_aguilef_gallegos",
              "id_candidato_servel": 10219549,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "emma_patricia_cifuentes_barrientos",
              "id_candidato_servel": 10486198,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_de_la_maza_schleyer",
              "id_candidato_servel": 10488532,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gustavo_eduardo_davila_sepulveda",
              "id_candidato_servel": 10836331,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_liliana_ayora_cavour",
              "id_candidato_servel": 10982517,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marila_loreto_barrientos_trivinos",
              "id_candidato_servel": 13817897,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carola_cabeza_fuentes",
              "id_candidato_servel": 14036888,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisco_isidoro_henriquez_munoz",
              "id_candidato_servel": 15354219,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_lamas_gutierrez",
              "id_candidato_servel": 15734731,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_andres_arzola_garrido",
              "id_candidato_servel": 15797290,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_francesca_claverol_martinez",
              "id_candidato_servel": 16096392,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_amanda_ochoa_hinrichsen",
              "id_candidato_servel": 16805216,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "madelin_yosette_jau_jaramillo",
              "id_candidato_servel": 16805952,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_gallardo_cardenas",
              "id_candidato_servel": 18913745,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2821,
          "resultados": [
            {
              "id_candidato": "miguel_david_ramirez_carvajal",
              "id_candidato_servel": 5280504,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alejandro_kohler_vargas",
              "id_candidato_servel": 6530889,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_antonio_urrutia_riesco",
              "id_candidato_servel": 7011719,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_silva_guerrero",
              "id_candidato_servel": 7143674,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "oscar_eduardo_mendoza_uriarte",
              "id_candidato_servel": 8094886,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_barriga_parra",
              "id_candidato_servel": 8897628,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_sonia_aguilef_gallegos",
              "id_candidato_servel": 10219549,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "emma_patricia_cifuentes_barrientos",
              "id_candidato_servel": 10486198,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_de_la_maza_schleyer",
              "id_candidato_servel": 10488532,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gustavo_eduardo_davila_sepulveda",
              "id_candidato_servel": 10836331,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_liliana_ayora_cavour",
              "id_candidato_servel": 10982517,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marila_loreto_barrientos_trivinos",
              "id_candidato_servel": 13817897,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carola_cabeza_fuentes",
              "id_candidato_servel": 14036888,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisco_isidoro_henriquez_munoz",
              "id_candidato_servel": 15354219,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pedro_lamas_gutierrez",
              "id_candidato_servel": 15734731,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "daniel_andres_arzola_garrido",
              "id_candidato_servel": 15797290,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_francesca_claverol_martinez",
              "id_candidato_servel": 16096392,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valeria_amanda_ochoa_hinrichsen",
              "id_candidato_servel": 16805216,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "madelin_yosette_jau_jaramillo",
              "id_candidato_servel": 16805952,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_gallardo_cardenas",
              "id_candidato_servel": 18913745,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "13",
      "resultados": [
        {
          "id_candidato": "rosa_alejandra_andrade_manquemilla",
          "id_candidato_servel": 15645102,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carolina_garcia_vera",
          "id_candidato_servel": 17639434,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "beatriz_isabel_hevia_willer",
          "id_candidato_servel": 18239161,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "guillermo_enrique_palacios_contreras",
          "id_candidato_servel": 12713168,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "lorena_denisse_leichtle_bertin",
          "id_candidato_servel": 15298375,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "alvaro_fabian_ojeda_alvarado",
          "id_candidato_servel": 18493072,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "juan_carlos_duhalde_romero",
          "id_candidato_servel": 8143228,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "eduardo_raul_alvarez_vidal",
          "id_candidato_servel": 17742839,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "gloria_maritza_hurtado_garay",
          "id_candidato_servel": 8418777,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "lorena_ester_perez_toro",
          "id_candidato_servel": 13901251,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "fernando_sebastian_barria_oyarzo",
          "id_candidato_servel": 21104846,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "maximiliano_arturo_urrutia_quezada",
          "id_candidato_servel": 8722148,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "patricia_sanzana_cardenas",
          "id_candidato_servel": 8692707,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carlos_recondo_lavanderos",
          "id_candidato_servel": 7832398,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "juan_luis_ossa_santa_cruz",
          "id_candidato_servel": 15382418,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "evelyn_zottele_garcia",
          "id_candidato_servel": 6928545,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "yanina_beatriz_diaz_mayorga",
          "id_candidato_servel": 11926917,
          "id_pacto": 377,
          "id_partido": 45,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "samuel_andres_galvez_derpich",
          "id_candidato_servel": 16349659,
          "id_pacto": 377,
          "id_partido": 137,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "nancy_carola_marquez_gonzalez",
          "id_candidato_servel": 13850107,
          "id_pacto": 377,
          "id_partido": 149,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "eduardo_castro_rios",
          "id_candidato_servel": 7907269,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2710,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2711,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2712,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2713,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2715,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2726,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2727,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2728,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2729,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2730,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2731,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2732,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2707,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2708,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2709,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2714,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2716,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2717,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2718,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2719,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2720,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2721,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2722,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2723,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2724,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2725,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2733,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2734,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2735,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2736,
          "resultados": [
            {
              "id_candidato": "evelyn_zottele_garcia",
              "id_candidato_servel": 6928545,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carlos_recondo_lavanderos",
              "id_candidato_servel": 7832398,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_castro_rios",
              "id_candidato_servel": 7907269,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_carlos_duhalde_romero",
              "id_candidato_servel": 8143228,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "gloria_maritza_hurtado_garay",
              "id_candidato_servel": 8418777,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "patricia_sanzana_cardenas",
              "id_candidato_servel": 8692707,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maximiliano_arturo_urrutia_quezada",
              "id_candidato_servel": 8722148,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "yanina_beatriz_diaz_mayorga",
              "id_candidato_servel": 11926917,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "guillermo_enrique_palacios_contreras",
              "id_candidato_servel": 12713168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nancy_carola_marquez_gonzalez",
              "id_candidato_servel": 13850107,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_ester_perez_toro",
              "id_candidato_servel": 13901251,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_denisse_leichtle_bertin",
              "id_candidato_servel": 15298375,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_ossa_santa_cruz",
              "id_candidato_servel": 15382418,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "rosa_alejandra_andrade_manquemilla",
              "id_candidato_servel": 15645102,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "samuel_andres_galvez_derpich",
              "id_candidato_servel": 16349659,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_garcia_vera",
              "id_candidato_servel": 17639434,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "eduardo_raul_alvarez_vidal",
              "id_candidato_servel": 17742839,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "beatriz_isabel_hevia_willer",
              "id_candidato_servel": 18239161,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "alvaro_fabian_ojeda_alvarado",
              "id_candidato_servel": 18493072,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_sebastian_barria_oyarzo",
              "id_candidato_servel": 21104846,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "14",
      "resultados": [
        {
          "id_candidato": "luis_alberto_soto_soto",
          "id_candidato_servel": 9054033,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "paola_elizabeth_velasquez_mansilla",
          "id_candidato_servel": 16534062,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "juan_mario_reyes_uribe",
          "id_candidato_servel": 10933275,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "sandra_angelica_mansilla_arriagada",
          "id_candidato_servel": 15968809,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "paulina_alejandra_perez_rubilar",
          "id_candidato_servel": 15965296,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "andres_zaldivar_larrain",
          "id_candidato_servel": 3244592,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "tamara_yoseline_villegas_redlich",
          "id_candidato_servel": 15965291,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "elvis_godoy_furnier",
          "id_candidato_servel": 12001523,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "liset_noelia_quilodran_quininao",
          "id_candidato_servel": 18437189,
          "id_pacto": 382,
          "id_partido": 99,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "andrea_ponce_olivares",
          "id_candidato_servel": 10335642,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "cristian_suazo_chacon",
          "id_candidato_servel": 11890533,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "diego_silva_barrera",
          "id_candidato_servel": 18282101,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "pilar_cuevas_mardones",
          "id_candidato_servel": 9065357,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "julio_francisco_nanco_antilef",
          "id_candidato_servel": 13244595,
          "id_pacto": 377,
          "id_partido": 45,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "lorena_soza_hernandez",
          "id_candidato_servel": 9893634,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "erwin_jonathan_sandoval_gallardo",
          "id_candidato_servel": 16684435,
          "id_pacto": 377,
          "id_partido": 130,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "valentina_gabriela_millalonco_vargas",
          "id_candidato_servel": 8687334,
          "id_pacto": 377,
          "id_partido": 6,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "josue_natanael_millanao_pezo",
          "id_candidato_servel": 20318005,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "fernando_eduardo_augusto_san_cristobal_brahm",
          "id_candidato_servel": 17602172,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "nieves_antonia_cuevas_torres",
          "id_candidato_servel": 9853314,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "luz_valeria_villegas_ojeda",
          "id_candidato_servel": 15304860,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2737,
          "resultados": [
            {
              "id_candidato": "andres_zaldivar_larrain",
              "id_candidato_servel": 3244592,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentina_gabriela_millalonco_vargas",
              "id_candidato_servel": 8687334,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_alberto_soto_soto",
              "id_candidato_servel": 9054033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_cuevas_mardones",
              "id_candidato_servel": 9065357,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nieves_antonia_cuevas_torres",
              "id_candidato_servel": 9853314,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_soza_hernandez",
              "id_candidato_servel": 9893634,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_ponce_olivares",
              "id_candidato_servel": 10335642,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_mario_reyes_uribe",
              "id_candidato_servel": 10933275,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_suazo_chacon",
              "id_candidato_servel": 11890533,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elvis_godoy_furnier",
              "id_candidato_servel": 12001523,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_francisco_nanco_antilef",
              "id_candidato_servel": 13244595,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_valeria_villegas_ojeda",
              "id_candidato_servel": 15304860,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_yoseline_villegas_redlich",
              "id_candidato_servel": 15965291,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paulina_alejandra_perez_rubilar",
              "id_candidato_servel": 15965296,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_angelica_mansilla_arriagada",
              "id_candidato_servel": 15968809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_elizabeth_velasquez_mansilla",
              "id_candidato_servel": 16534062,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erwin_jonathan_sandoval_gallardo",
              "id_candidato_servel": 16684435,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_eduardo_augusto_san_cristobal_brahm",
              "id_candidato_servel": 17602172,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "diego_silva_barrera",
              "id_candidato_servel": 18282101,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liset_noelia_quilodran_quininao",
              "id_candidato_servel": 18437189,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josue_natanael_millanao_pezo",
              "id_candidato_servel": 20318005,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2738,
          "resultados": [
            {
              "id_candidato": "andres_zaldivar_larrain",
              "id_candidato_servel": 3244592,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentina_gabriela_millalonco_vargas",
              "id_candidato_servel": 8687334,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_alberto_soto_soto",
              "id_candidato_servel": 9054033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_cuevas_mardones",
              "id_candidato_servel": 9065357,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nieves_antonia_cuevas_torres",
              "id_candidato_servel": 9853314,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_soza_hernandez",
              "id_candidato_servel": 9893634,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_ponce_olivares",
              "id_candidato_servel": 10335642,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_mario_reyes_uribe",
              "id_candidato_servel": 10933275,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_suazo_chacon",
              "id_candidato_servel": 11890533,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elvis_godoy_furnier",
              "id_candidato_servel": 12001523,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_francisco_nanco_antilef",
              "id_candidato_servel": 13244595,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_valeria_villegas_ojeda",
              "id_candidato_servel": 15304860,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_yoseline_villegas_redlich",
              "id_candidato_servel": 15965291,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paulina_alejandra_perez_rubilar",
              "id_candidato_servel": 15965296,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_angelica_mansilla_arriagada",
              "id_candidato_servel": 15968809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_elizabeth_velasquez_mansilla",
              "id_candidato_servel": 16534062,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erwin_jonathan_sandoval_gallardo",
              "id_candidato_servel": 16684435,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_eduardo_augusto_san_cristobal_brahm",
              "id_candidato_servel": 17602172,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "diego_silva_barrera",
              "id_candidato_servel": 18282101,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liset_noelia_quilodran_quininao",
              "id_candidato_servel": 18437189,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josue_natanael_millanao_pezo",
              "id_candidato_servel": 20318005,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2739,
          "resultados": [
            {
              "id_candidato": "andres_zaldivar_larrain",
              "id_candidato_servel": 3244592,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentina_gabriela_millalonco_vargas",
              "id_candidato_servel": 8687334,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_alberto_soto_soto",
              "id_candidato_servel": 9054033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_cuevas_mardones",
              "id_candidato_servel": 9065357,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nieves_antonia_cuevas_torres",
              "id_candidato_servel": 9853314,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_soza_hernandez",
              "id_candidato_servel": 9893634,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_ponce_olivares",
              "id_candidato_servel": 10335642,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_mario_reyes_uribe",
              "id_candidato_servel": 10933275,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_suazo_chacon",
              "id_candidato_servel": 11890533,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elvis_godoy_furnier",
              "id_candidato_servel": 12001523,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_francisco_nanco_antilef",
              "id_candidato_servel": 13244595,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_valeria_villegas_ojeda",
              "id_candidato_servel": 15304860,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_yoseline_villegas_redlich",
              "id_candidato_servel": 15965291,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paulina_alejandra_perez_rubilar",
              "id_candidato_servel": 15965296,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_angelica_mansilla_arriagada",
              "id_candidato_servel": 15968809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_elizabeth_velasquez_mansilla",
              "id_candidato_servel": 16534062,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erwin_jonathan_sandoval_gallardo",
              "id_candidato_servel": 16684435,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_eduardo_augusto_san_cristobal_brahm",
              "id_candidato_servel": 17602172,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "diego_silva_barrera",
              "id_candidato_servel": 18282101,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liset_noelia_quilodran_quininao",
              "id_candidato_servel": 18437189,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josue_natanael_millanao_pezo",
              "id_candidato_servel": 20318005,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2740,
          "resultados": [
            {
              "id_candidato": "andres_zaldivar_larrain",
              "id_candidato_servel": 3244592,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentina_gabriela_millalonco_vargas",
              "id_candidato_servel": 8687334,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_alberto_soto_soto",
              "id_candidato_servel": 9054033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_cuevas_mardones",
              "id_candidato_servel": 9065357,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nieves_antonia_cuevas_torres",
              "id_candidato_servel": 9853314,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_soza_hernandez",
              "id_candidato_servel": 9893634,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_ponce_olivares",
              "id_candidato_servel": 10335642,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_mario_reyes_uribe",
              "id_candidato_servel": 10933275,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_suazo_chacon",
              "id_candidato_servel": 11890533,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elvis_godoy_furnier",
              "id_candidato_servel": 12001523,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_francisco_nanco_antilef",
              "id_candidato_servel": 13244595,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_valeria_villegas_ojeda",
              "id_candidato_servel": 15304860,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_yoseline_villegas_redlich",
              "id_candidato_servel": 15965291,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paulina_alejandra_perez_rubilar",
              "id_candidato_servel": 15965296,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_angelica_mansilla_arriagada",
              "id_candidato_servel": 15968809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_elizabeth_velasquez_mansilla",
              "id_candidato_servel": 16534062,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erwin_jonathan_sandoval_gallardo",
              "id_candidato_servel": 16684435,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_eduardo_augusto_san_cristobal_brahm",
              "id_candidato_servel": 17602172,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "diego_silva_barrera",
              "id_candidato_servel": 18282101,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liset_noelia_quilodran_quininao",
              "id_candidato_servel": 18437189,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josue_natanael_millanao_pezo",
              "id_candidato_servel": 20318005,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2741,
          "resultados": [
            {
              "id_candidato": "andres_zaldivar_larrain",
              "id_candidato_servel": 3244592,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentina_gabriela_millalonco_vargas",
              "id_candidato_servel": 8687334,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_alberto_soto_soto",
              "id_candidato_servel": 9054033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_cuevas_mardones",
              "id_candidato_servel": 9065357,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nieves_antonia_cuevas_torres",
              "id_candidato_servel": 9853314,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_soza_hernandez",
              "id_candidato_servel": 9893634,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_ponce_olivares",
              "id_candidato_servel": 10335642,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_mario_reyes_uribe",
              "id_candidato_servel": 10933275,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_suazo_chacon",
              "id_candidato_servel": 11890533,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elvis_godoy_furnier",
              "id_candidato_servel": 12001523,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_francisco_nanco_antilef",
              "id_candidato_servel": 13244595,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_valeria_villegas_ojeda",
              "id_candidato_servel": 15304860,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_yoseline_villegas_redlich",
              "id_candidato_servel": 15965291,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paulina_alejandra_perez_rubilar",
              "id_candidato_servel": 15965296,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_angelica_mansilla_arriagada",
              "id_candidato_servel": 15968809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_elizabeth_velasquez_mansilla",
              "id_candidato_servel": 16534062,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erwin_jonathan_sandoval_gallardo",
              "id_candidato_servel": 16684435,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_eduardo_augusto_san_cristobal_brahm",
              "id_candidato_servel": 17602172,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "diego_silva_barrera",
              "id_candidato_servel": 18282101,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liset_noelia_quilodran_quininao",
              "id_candidato_servel": 18437189,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josue_natanael_millanao_pezo",
              "id_candidato_servel": 20318005,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2742,
          "resultados": [
            {
              "id_candidato": "andres_zaldivar_larrain",
              "id_candidato_servel": 3244592,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentina_gabriela_millalonco_vargas",
              "id_candidato_servel": 8687334,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_alberto_soto_soto",
              "id_candidato_servel": 9054033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_cuevas_mardones",
              "id_candidato_servel": 9065357,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nieves_antonia_cuevas_torres",
              "id_candidato_servel": 9853314,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_soza_hernandez",
              "id_candidato_servel": 9893634,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_ponce_olivares",
              "id_candidato_servel": 10335642,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_mario_reyes_uribe",
              "id_candidato_servel": 10933275,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_suazo_chacon",
              "id_candidato_servel": 11890533,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elvis_godoy_furnier",
              "id_candidato_servel": 12001523,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_francisco_nanco_antilef",
              "id_candidato_servel": 13244595,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_valeria_villegas_ojeda",
              "id_candidato_servel": 15304860,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_yoseline_villegas_redlich",
              "id_candidato_servel": 15965291,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paulina_alejandra_perez_rubilar",
              "id_candidato_servel": 15965296,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_angelica_mansilla_arriagada",
              "id_candidato_servel": 15968809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_elizabeth_velasquez_mansilla",
              "id_candidato_servel": 16534062,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erwin_jonathan_sandoval_gallardo",
              "id_candidato_servel": 16684435,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_eduardo_augusto_san_cristobal_brahm",
              "id_candidato_servel": 17602172,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "diego_silva_barrera",
              "id_candidato_servel": 18282101,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liset_noelia_quilodran_quininao",
              "id_candidato_servel": 18437189,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josue_natanael_millanao_pezo",
              "id_candidato_servel": 20318005,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2743,
          "resultados": [
            {
              "id_candidato": "andres_zaldivar_larrain",
              "id_candidato_servel": 3244592,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentina_gabriela_millalonco_vargas",
              "id_candidato_servel": 8687334,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_alberto_soto_soto",
              "id_candidato_servel": 9054033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_cuevas_mardones",
              "id_candidato_servel": 9065357,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nieves_antonia_cuevas_torres",
              "id_candidato_servel": 9853314,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_soza_hernandez",
              "id_candidato_servel": 9893634,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_ponce_olivares",
              "id_candidato_servel": 10335642,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_mario_reyes_uribe",
              "id_candidato_servel": 10933275,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_suazo_chacon",
              "id_candidato_servel": 11890533,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elvis_godoy_furnier",
              "id_candidato_servel": 12001523,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_francisco_nanco_antilef",
              "id_candidato_servel": 13244595,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_valeria_villegas_ojeda",
              "id_candidato_servel": 15304860,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_yoseline_villegas_redlich",
              "id_candidato_servel": 15965291,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paulina_alejandra_perez_rubilar",
              "id_candidato_servel": 15965296,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_angelica_mansilla_arriagada",
              "id_candidato_servel": 15968809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_elizabeth_velasquez_mansilla",
              "id_candidato_servel": 16534062,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erwin_jonathan_sandoval_gallardo",
              "id_candidato_servel": 16684435,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_eduardo_augusto_san_cristobal_brahm",
              "id_candidato_servel": 17602172,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "diego_silva_barrera",
              "id_candidato_servel": 18282101,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liset_noelia_quilodran_quininao",
              "id_candidato_servel": 18437189,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josue_natanael_millanao_pezo",
              "id_candidato_servel": 20318005,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2744,
          "resultados": [
            {
              "id_candidato": "andres_zaldivar_larrain",
              "id_candidato_servel": 3244592,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentina_gabriela_millalonco_vargas",
              "id_candidato_servel": 8687334,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_alberto_soto_soto",
              "id_candidato_servel": 9054033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_cuevas_mardones",
              "id_candidato_servel": 9065357,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nieves_antonia_cuevas_torres",
              "id_candidato_servel": 9853314,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_soza_hernandez",
              "id_candidato_servel": 9893634,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_ponce_olivares",
              "id_candidato_servel": 10335642,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_mario_reyes_uribe",
              "id_candidato_servel": 10933275,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_suazo_chacon",
              "id_candidato_servel": 11890533,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elvis_godoy_furnier",
              "id_candidato_servel": 12001523,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_francisco_nanco_antilef",
              "id_candidato_servel": 13244595,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_valeria_villegas_ojeda",
              "id_candidato_servel": 15304860,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_yoseline_villegas_redlich",
              "id_candidato_servel": 15965291,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paulina_alejandra_perez_rubilar",
              "id_candidato_servel": 15965296,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_angelica_mansilla_arriagada",
              "id_candidato_servel": 15968809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_elizabeth_velasquez_mansilla",
              "id_candidato_servel": 16534062,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erwin_jonathan_sandoval_gallardo",
              "id_candidato_servel": 16684435,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_eduardo_augusto_san_cristobal_brahm",
              "id_candidato_servel": 17602172,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "diego_silva_barrera",
              "id_candidato_servel": 18282101,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liset_noelia_quilodran_quininao",
              "id_candidato_servel": 18437189,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josue_natanael_millanao_pezo",
              "id_candidato_servel": 20318005,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2745,
          "resultados": [
            {
              "id_candidato": "andres_zaldivar_larrain",
              "id_candidato_servel": 3244592,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentina_gabriela_millalonco_vargas",
              "id_candidato_servel": 8687334,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_alberto_soto_soto",
              "id_candidato_servel": 9054033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_cuevas_mardones",
              "id_candidato_servel": 9065357,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nieves_antonia_cuevas_torres",
              "id_candidato_servel": 9853314,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_soza_hernandez",
              "id_candidato_servel": 9893634,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_ponce_olivares",
              "id_candidato_servel": 10335642,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_mario_reyes_uribe",
              "id_candidato_servel": 10933275,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_suazo_chacon",
              "id_candidato_servel": 11890533,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elvis_godoy_furnier",
              "id_candidato_servel": 12001523,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_francisco_nanco_antilef",
              "id_candidato_servel": 13244595,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_valeria_villegas_ojeda",
              "id_candidato_servel": 15304860,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_yoseline_villegas_redlich",
              "id_candidato_servel": 15965291,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paulina_alejandra_perez_rubilar",
              "id_candidato_servel": 15965296,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_angelica_mansilla_arriagada",
              "id_candidato_servel": 15968809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_elizabeth_velasquez_mansilla",
              "id_candidato_servel": 16534062,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erwin_jonathan_sandoval_gallardo",
              "id_candidato_servel": 16684435,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_eduardo_augusto_san_cristobal_brahm",
              "id_candidato_servel": 17602172,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "diego_silva_barrera",
              "id_candidato_servel": 18282101,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liset_noelia_quilodran_quininao",
              "id_candidato_servel": 18437189,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josue_natanael_millanao_pezo",
              "id_candidato_servel": 20318005,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2746,
          "resultados": [
            {
              "id_candidato": "andres_zaldivar_larrain",
              "id_candidato_servel": 3244592,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "valentina_gabriela_millalonco_vargas",
              "id_candidato_servel": 8687334,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luis_alberto_soto_soto",
              "id_candidato_servel": 9054033,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pilar_cuevas_mardones",
              "id_candidato_servel": 9065357,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "nieves_antonia_cuevas_torres",
              "id_candidato_servel": 9853314,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "lorena_soza_hernandez",
              "id_candidato_servel": 9893634,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_ponce_olivares",
              "id_candidato_servel": 10335642,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_mario_reyes_uribe",
              "id_candidato_servel": 10933275,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cristian_suazo_chacon",
              "id_candidato_servel": 11890533,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "elvis_godoy_furnier",
              "id_candidato_servel": 12001523,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_francisco_nanco_antilef",
              "id_candidato_servel": 13244595,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_valeria_villegas_ojeda",
              "id_candidato_servel": 15304860,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "tamara_yoseline_villegas_redlich",
              "id_candidato_servel": 15965291,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paulina_alejandra_perez_rubilar",
              "id_candidato_servel": 15965296,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_angelica_mansilla_arriagada",
              "id_candidato_servel": 15968809,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "paola_elizabeth_velasquez_mansilla",
              "id_candidato_servel": 16534062,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "erwin_jonathan_sandoval_gallardo",
              "id_candidato_servel": 16684435,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "fernando_eduardo_augusto_san_cristobal_brahm",
              "id_candidato_servel": 17602172,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "diego_silva_barrera",
              "id_candidato_servel": 18282101,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "liset_noelia_quilodran_quininao",
              "id_candidato_servel": 18437189,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josue_natanael_millanao_pezo",
              "id_candidato_servel": 20318005,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "15",
      "resultados": [
        {
          "id_candidato": "andrea_pivcevic_cortese",
          "id_candidato_servel": 10676684,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "victor_hernan_aravena_gutierrez",
          "id_candidato_servel": 12382102,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "ignacio_andres_quijada_loncharic",
          "id_candidato_servel": 16964848,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "victor_mauricio_hernandez_godoy",
          "id_candidato_servel": 8233596,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "victoria_trapp_moreira",
          "id_candidato_servel": 19861939,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "robert_kurt_weissohn_heck",
          "id_candidato_servel": 5842527,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "claudia_alejandra_maclean_bravo",
          "id_candidato_servel": 16163658,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "luz_helena_guzman_garcia",
          "id_candidato_servel": 14744752,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "claudio_andres_barrientos_mol",
          "id_candidato_servel": 13409217,
          "id_pacto": 382,
          "id_partido": 99,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "marcelo_andres_toledo_toledo",
          "id_candidato_servel": 11401637,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "veronica_del_carmen_rojas_arenas",
          "id_candidato_servel": 7689686,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "francisca_rojas_philippi",
          "id_candidato_servel": 12722201,
          "id_pacto": 379,
          "id_partido": 37,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "ariel_mihovilovic_bonardi",
          "id_candidato_servel": 10050616,
          "id_pacto": 379,
          "id_partido": 37,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "alfonso_campos_gonzalez",
          "id_candidato_servel": 4814138,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "cecilia_cardenas_reyes",
          "id_candidato_servel": 14476262,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "pablo_bussenius_cornejo",
          "id_candidato_servel": 12253804,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "constanza_monserrat_aguilar_herrera",
          "id_candidato_servel": 21139205,
          "id_pacto": 377,
          "id_partido": 6,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "julio_gaston_contreras_munoz",
          "id_candidato_servel": 7406584,
          "id_pacto": 377,
          "id_partido": 149,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jessica_milena_bengoa_mayorga",
          "id_candidato_servel": 9313223,
          "id_pacto": 377,
          "id_partido": 149,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2747,
          "resultados": [
            {
              "id_candidato": "alfonso_campos_gonzalez",
              "id_candidato_servel": 4814138,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_kurt_weissohn_heck",
              "id_candidato_servel": 5842527,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_gaston_contreras_munoz",
              "id_candidato_servel": 7406584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_del_carmen_rojas_arenas",
              "id_candidato_servel": 7689686,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_mauricio_hernandez_godoy",
              "id_candidato_servel": 8233596,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_milena_bengoa_mayorga",
              "id_candidato_servel": 9313223,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ariel_mihovilovic_bonardi",
              "id_candidato_servel": 10050616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_pivcevic_cortese",
              "id_candidato_servel": 10676684,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_andres_toledo_toledo",
              "id_candidato_servel": 11401637,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_bussenius_cornejo",
              "id_candidato_servel": 12253804,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hernan_aravena_gutierrez",
              "id_candidato_servel": 12382102,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_rojas_philippi",
              "id_candidato_servel": 12722201,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_barrientos_mol",
              "id_candidato_servel": 13409217,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_cardenas_reyes",
              "id_candidato_servel": 14476262,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_helena_guzman_garcia",
              "id_candidato_servel": 14744752,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_alejandra_maclean_bravo",
              "id_candidato_servel": 16163658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_quijada_loncharic",
              "id_candidato_servel": 16964848,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_trapp_moreira",
              "id_candidato_servel": 19861939,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_monserrat_aguilar_herrera",
              "id_candidato_servel": 21139205,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2748,
          "resultados": [
            {
              "id_candidato": "alfonso_campos_gonzalez",
              "id_candidato_servel": 4814138,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_kurt_weissohn_heck",
              "id_candidato_servel": 5842527,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_gaston_contreras_munoz",
              "id_candidato_servel": 7406584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_del_carmen_rojas_arenas",
              "id_candidato_servel": 7689686,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_mauricio_hernandez_godoy",
              "id_candidato_servel": 8233596,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_milena_bengoa_mayorga",
              "id_candidato_servel": 9313223,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ariel_mihovilovic_bonardi",
              "id_candidato_servel": 10050616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_pivcevic_cortese",
              "id_candidato_servel": 10676684,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_andres_toledo_toledo",
              "id_candidato_servel": 11401637,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_bussenius_cornejo",
              "id_candidato_servel": 12253804,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hernan_aravena_gutierrez",
              "id_candidato_servel": 12382102,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_rojas_philippi",
              "id_candidato_servel": 12722201,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_barrientos_mol",
              "id_candidato_servel": 13409217,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_cardenas_reyes",
              "id_candidato_servel": 14476262,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_helena_guzman_garcia",
              "id_candidato_servel": 14744752,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_alejandra_maclean_bravo",
              "id_candidato_servel": 16163658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_quijada_loncharic",
              "id_candidato_servel": 16964848,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_trapp_moreira",
              "id_candidato_servel": 19861939,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_monserrat_aguilar_herrera",
              "id_candidato_servel": 21139205,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2749,
          "resultados": [
            {
              "id_candidato": "alfonso_campos_gonzalez",
              "id_candidato_servel": 4814138,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_kurt_weissohn_heck",
              "id_candidato_servel": 5842527,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_gaston_contreras_munoz",
              "id_candidato_servel": 7406584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_del_carmen_rojas_arenas",
              "id_candidato_servel": 7689686,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_mauricio_hernandez_godoy",
              "id_candidato_servel": 8233596,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_milena_bengoa_mayorga",
              "id_candidato_servel": 9313223,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ariel_mihovilovic_bonardi",
              "id_candidato_servel": 10050616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_pivcevic_cortese",
              "id_candidato_servel": 10676684,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_andres_toledo_toledo",
              "id_candidato_servel": 11401637,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_bussenius_cornejo",
              "id_candidato_servel": 12253804,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hernan_aravena_gutierrez",
              "id_candidato_servel": 12382102,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_rojas_philippi",
              "id_candidato_servel": 12722201,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_barrientos_mol",
              "id_candidato_servel": 13409217,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_cardenas_reyes",
              "id_candidato_servel": 14476262,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_helena_guzman_garcia",
              "id_candidato_servel": 14744752,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_alejandra_maclean_bravo",
              "id_candidato_servel": 16163658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_quijada_loncharic",
              "id_candidato_servel": 16964848,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_trapp_moreira",
              "id_candidato_servel": 19861939,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_monserrat_aguilar_herrera",
              "id_candidato_servel": 21139205,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2750,
          "resultados": [
            {
              "id_candidato": "alfonso_campos_gonzalez",
              "id_candidato_servel": 4814138,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_kurt_weissohn_heck",
              "id_candidato_servel": 5842527,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_gaston_contreras_munoz",
              "id_candidato_servel": 7406584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_del_carmen_rojas_arenas",
              "id_candidato_servel": 7689686,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_mauricio_hernandez_godoy",
              "id_candidato_servel": 8233596,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_milena_bengoa_mayorga",
              "id_candidato_servel": 9313223,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ariel_mihovilovic_bonardi",
              "id_candidato_servel": 10050616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_pivcevic_cortese",
              "id_candidato_servel": 10676684,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_andres_toledo_toledo",
              "id_candidato_servel": 11401637,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_bussenius_cornejo",
              "id_candidato_servel": 12253804,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hernan_aravena_gutierrez",
              "id_candidato_servel": 12382102,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_rojas_philippi",
              "id_candidato_servel": 12722201,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_barrientos_mol",
              "id_candidato_servel": 13409217,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_cardenas_reyes",
              "id_candidato_servel": 14476262,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_helena_guzman_garcia",
              "id_candidato_servel": 14744752,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_alejandra_maclean_bravo",
              "id_candidato_servel": 16163658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_quijada_loncharic",
              "id_candidato_servel": 16964848,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_trapp_moreira",
              "id_candidato_servel": 19861939,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_monserrat_aguilar_herrera",
              "id_candidato_servel": 21139205,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2751,
          "resultados": [
            {
              "id_candidato": "alfonso_campos_gonzalez",
              "id_candidato_servel": 4814138,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_kurt_weissohn_heck",
              "id_candidato_servel": 5842527,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_gaston_contreras_munoz",
              "id_candidato_servel": 7406584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_del_carmen_rojas_arenas",
              "id_candidato_servel": 7689686,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_mauricio_hernandez_godoy",
              "id_candidato_servel": 8233596,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_milena_bengoa_mayorga",
              "id_candidato_servel": 9313223,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ariel_mihovilovic_bonardi",
              "id_candidato_servel": 10050616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_pivcevic_cortese",
              "id_candidato_servel": 10676684,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_andres_toledo_toledo",
              "id_candidato_servel": 11401637,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_bussenius_cornejo",
              "id_candidato_servel": 12253804,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hernan_aravena_gutierrez",
              "id_candidato_servel": 12382102,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_rojas_philippi",
              "id_candidato_servel": 12722201,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_barrientos_mol",
              "id_candidato_servel": 13409217,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_cardenas_reyes",
              "id_candidato_servel": 14476262,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_helena_guzman_garcia",
              "id_candidato_servel": 14744752,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_alejandra_maclean_bravo",
              "id_candidato_servel": 16163658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_quijada_loncharic",
              "id_candidato_servel": 16964848,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_trapp_moreira",
              "id_candidato_servel": 19861939,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_monserrat_aguilar_herrera",
              "id_candidato_servel": 21139205,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2752,
          "resultados": [
            {
              "id_candidato": "alfonso_campos_gonzalez",
              "id_candidato_servel": 4814138,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_kurt_weissohn_heck",
              "id_candidato_servel": 5842527,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_gaston_contreras_munoz",
              "id_candidato_servel": 7406584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_del_carmen_rojas_arenas",
              "id_candidato_servel": 7689686,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_mauricio_hernandez_godoy",
              "id_candidato_servel": 8233596,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_milena_bengoa_mayorga",
              "id_candidato_servel": 9313223,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ariel_mihovilovic_bonardi",
              "id_candidato_servel": 10050616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_pivcevic_cortese",
              "id_candidato_servel": 10676684,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_andres_toledo_toledo",
              "id_candidato_servel": 11401637,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_bussenius_cornejo",
              "id_candidato_servel": 12253804,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hernan_aravena_gutierrez",
              "id_candidato_servel": 12382102,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_rojas_philippi",
              "id_candidato_servel": 12722201,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_barrientos_mol",
              "id_candidato_servel": 13409217,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_cardenas_reyes",
              "id_candidato_servel": 14476262,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_helena_guzman_garcia",
              "id_candidato_servel": 14744752,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_alejandra_maclean_bravo",
              "id_candidato_servel": 16163658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_quijada_loncharic",
              "id_candidato_servel": 16964848,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_trapp_moreira",
              "id_candidato_servel": 19861939,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_monserrat_aguilar_herrera",
              "id_candidato_servel": 21139205,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2753,
          "resultados": [
            {
              "id_candidato": "alfonso_campos_gonzalez",
              "id_candidato_servel": 4814138,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_kurt_weissohn_heck",
              "id_candidato_servel": 5842527,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_gaston_contreras_munoz",
              "id_candidato_servel": 7406584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_del_carmen_rojas_arenas",
              "id_candidato_servel": 7689686,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_mauricio_hernandez_godoy",
              "id_candidato_servel": 8233596,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_milena_bengoa_mayorga",
              "id_candidato_servel": 9313223,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ariel_mihovilovic_bonardi",
              "id_candidato_servel": 10050616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_pivcevic_cortese",
              "id_candidato_servel": 10676684,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_andres_toledo_toledo",
              "id_candidato_servel": 11401637,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_bussenius_cornejo",
              "id_candidato_servel": 12253804,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hernan_aravena_gutierrez",
              "id_candidato_servel": 12382102,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_rojas_philippi",
              "id_candidato_servel": 12722201,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_barrientos_mol",
              "id_candidato_servel": 13409217,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_cardenas_reyes",
              "id_candidato_servel": 14476262,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_helena_guzman_garcia",
              "id_candidato_servel": 14744752,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_alejandra_maclean_bravo",
              "id_candidato_servel": 16163658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_quijada_loncharic",
              "id_candidato_servel": 16964848,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_trapp_moreira",
              "id_candidato_servel": 19861939,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_monserrat_aguilar_herrera",
              "id_candidato_servel": 21139205,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2754,
          "resultados": [
            {
              "id_candidato": "alfonso_campos_gonzalez",
              "id_candidato_servel": 4814138,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_kurt_weissohn_heck",
              "id_candidato_servel": 5842527,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_gaston_contreras_munoz",
              "id_candidato_servel": 7406584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_del_carmen_rojas_arenas",
              "id_candidato_servel": 7689686,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_mauricio_hernandez_godoy",
              "id_candidato_servel": 8233596,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_milena_bengoa_mayorga",
              "id_candidato_servel": 9313223,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ariel_mihovilovic_bonardi",
              "id_candidato_servel": 10050616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_pivcevic_cortese",
              "id_candidato_servel": 10676684,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_andres_toledo_toledo",
              "id_candidato_servel": 11401637,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_bussenius_cornejo",
              "id_candidato_servel": 12253804,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hernan_aravena_gutierrez",
              "id_candidato_servel": 12382102,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_rojas_philippi",
              "id_candidato_servel": 12722201,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_barrientos_mol",
              "id_candidato_servel": 13409217,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_cardenas_reyes",
              "id_candidato_servel": 14476262,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_helena_guzman_garcia",
              "id_candidato_servel": 14744752,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_alejandra_maclean_bravo",
              "id_candidato_servel": 16163658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_quijada_loncharic",
              "id_candidato_servel": 16964848,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_trapp_moreira",
              "id_candidato_servel": 19861939,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_monserrat_aguilar_herrera",
              "id_candidato_servel": 21139205,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2755,
          "resultados": [
            {
              "id_candidato": "alfonso_campos_gonzalez",
              "id_candidato_servel": 4814138,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_kurt_weissohn_heck",
              "id_candidato_servel": 5842527,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_gaston_contreras_munoz",
              "id_candidato_servel": 7406584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_del_carmen_rojas_arenas",
              "id_candidato_servel": 7689686,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_mauricio_hernandez_godoy",
              "id_candidato_servel": 8233596,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_milena_bengoa_mayorga",
              "id_candidato_servel": 9313223,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ariel_mihovilovic_bonardi",
              "id_candidato_servel": 10050616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_pivcevic_cortese",
              "id_candidato_servel": 10676684,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_andres_toledo_toledo",
              "id_candidato_servel": 11401637,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_bussenius_cornejo",
              "id_candidato_servel": 12253804,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hernan_aravena_gutierrez",
              "id_candidato_servel": 12382102,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_rojas_philippi",
              "id_candidato_servel": 12722201,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_barrientos_mol",
              "id_candidato_servel": 13409217,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_cardenas_reyes",
              "id_candidato_servel": 14476262,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_helena_guzman_garcia",
              "id_candidato_servel": 14744752,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_alejandra_maclean_bravo",
              "id_candidato_servel": 16163658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_quijada_loncharic",
              "id_candidato_servel": 16964848,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_trapp_moreira",
              "id_candidato_servel": 19861939,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_monserrat_aguilar_herrera",
              "id_candidato_servel": 21139205,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2756,
          "resultados": [
            {
              "id_candidato": "alfonso_campos_gonzalez",
              "id_candidato_servel": 4814138,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_kurt_weissohn_heck",
              "id_candidato_servel": 5842527,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_gaston_contreras_munoz",
              "id_candidato_servel": 7406584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_del_carmen_rojas_arenas",
              "id_candidato_servel": 7689686,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_mauricio_hernandez_godoy",
              "id_candidato_servel": 8233596,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_milena_bengoa_mayorga",
              "id_candidato_servel": 9313223,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ariel_mihovilovic_bonardi",
              "id_candidato_servel": 10050616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_pivcevic_cortese",
              "id_candidato_servel": 10676684,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_andres_toledo_toledo",
              "id_candidato_servel": 11401637,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_bussenius_cornejo",
              "id_candidato_servel": 12253804,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hernan_aravena_gutierrez",
              "id_candidato_servel": 12382102,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_rojas_philippi",
              "id_candidato_servel": 12722201,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_barrientos_mol",
              "id_candidato_servel": 13409217,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_cardenas_reyes",
              "id_candidato_servel": 14476262,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_helena_guzman_garcia",
              "id_candidato_servel": 14744752,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_alejandra_maclean_bravo",
              "id_candidato_servel": 16163658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_quijada_loncharic",
              "id_candidato_servel": 16964848,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_trapp_moreira",
              "id_candidato_servel": 19861939,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_monserrat_aguilar_herrera",
              "id_candidato_servel": 21139205,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2757,
          "resultados": [
            {
              "id_candidato": "alfonso_campos_gonzalez",
              "id_candidato_servel": 4814138,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "robert_kurt_weissohn_heck",
              "id_candidato_servel": 5842527,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "julio_gaston_contreras_munoz",
              "id_candidato_servel": 7406584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "veronica_del_carmen_rojas_arenas",
              "id_candidato_servel": 7689686,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_mauricio_hernandez_godoy",
              "id_candidato_servel": 8233596,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jessica_milena_bengoa_mayorga",
              "id_candidato_servel": 9313223,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ariel_mihovilovic_bonardi",
              "id_candidato_servel": 10050616,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "andrea_pivcevic_cortese",
              "id_candidato_servel": 10676684,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "marcelo_andres_toledo_toledo",
              "id_candidato_servel": 11401637,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "pablo_bussenius_cornejo",
              "id_candidato_servel": 12253804,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victor_hernan_aravena_gutierrez",
              "id_candidato_servel": 12382102,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "francisca_rojas_philippi",
              "id_candidato_servel": 12722201,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_barrientos_mol",
              "id_candidato_servel": 13409217,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_cardenas_reyes",
              "id_candidato_servel": 14476262,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "luz_helena_guzman_garcia",
              "id_candidato_servel": 14744752,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudia_alejandra_maclean_bravo",
              "id_candidato_servel": 16163658,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ignacio_andres_quijada_loncharic",
              "id_candidato_servel": 16964848,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "victoria_trapp_moreira",
              "id_candidato_servel": 19861939,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "constanza_monserrat_aguilar_herrera",
              "id_candidato_servel": 21139205,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "16",
      "resultados": [
        {
          "id_candidato": "olga_maria_arzola_soto",
          "id_candidato_servel": 5797138,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "maria_elena_acuna_olivera",
          "id_candidato_servel": 5537755,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "aldo_dino_jose_bernucci_diaz",
          "id_candidato_servel": 5106131,
          "id_pacto": 378,
          "id_partido": 7,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "camila_torres_umanzor",
          "id_candidato_servel": 17248502,
          "id_pacto": 378,
          "id_partido": 4,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "ricardo_ivan_orellana_rojas",
          "id_candidato_servel": 6317119,
          "id_pacto": 378,
          "id_partido": 2,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "juan_luis_enriquez_fuentes",
          "id_candidato_servel": 11863307,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "cecilia_violeta_medina_meneses",
          "id_candidato_servel": 10426670,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "abraham_manuel_gonzalez_olave",
          "id_candidato_servel": 9043304,
          "id_pacto": 381,
          "id_partido": 150,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "etty_scarlette_solis_candia",
          "id_candidato_servel": 18411946,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "miguel_angel_segundo_chavez_mendoza",
          "id_candidato_servel": 7460922,
          "id_pacto": 380,
          "id_partido": 157,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "mario_rios_santander",
          "id_candidato_servel": 3929106,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "sandra_lama_larenas",
          "id_candidato_servel": 8680695,
          "id_pacto": 379,
          "id_partido": 1,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jorge_carrillo_villalobos",
          "id_candidato_servel": 18390168,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "carolina_navarrete_rubio",
          "id_candidato_servel": 17459257,
          "id_pacto": 379,
          "id_partido": 3,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "brigida_elizabeth_escalona_gonzalez",
          "id_candidato_servel": 9813500,
          "id_pacto": 377,
          "id_partido": 5,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
          "id_candidato_servel": 17459786,
          "id_pacto": 377,
          "id_partido": 149,
          "genero": "F",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "claudio_andres_ferrada_alarcon",
          "id_candidato_servel": 16445608,
          "id_pacto": 377,
          "id_partido": 45,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "jose_osvaldo_zuniga_pino",
          "id_candidato_servel": 11533584,
          "id_pacto": 377,
          "id_partido": 6,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": [
        {
          "comuna": 2826,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2827,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2828,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2829,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2830,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2831,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2832,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2833,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2834,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2835,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2836,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2837,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2838,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2839,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2840,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2841,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2842,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2843,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2844,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2845,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        },
        {
          "comuna": 2846,
          "resultados": [
            {
              "id_candidato": "mario_rios_santander",
              "id_candidato_servel": 3929106,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "aldo_dino_jose_bernucci_diaz",
              "id_candidato_servel": 5106131,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "maria_elena_acuna_olivera",
              "id_candidato_servel": 5537755,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "olga_maria_arzola_soto",
              "id_candidato_servel": 5797138,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "ricardo_ivan_orellana_rojas",
              "id_candidato_servel": 6317119,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "miguel_angel_segundo_chavez_mendoza",
              "id_candidato_servel": 7460922,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "sandra_lama_larenas",
              "id_candidato_servel": 8680695,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "abraham_manuel_gonzalez_olave",
              "id_candidato_servel": 9043304,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "brigida_elizabeth_escalona_gonzalez",
              "id_candidato_servel": 9813500,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "cecilia_violeta_medina_meneses",
              "id_candidato_servel": 10426670,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jose_osvaldo_zuniga_pino",
              "id_candidato_servel": 11533584,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "juan_luis_enriquez_fuentes",
              "id_candidato_servel": 11863307,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "claudio_andres_ferrada_alarcon",
              "id_candidato_servel": 16445608,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "camila_torres_umanzor",
              "id_candidato_servel": 17248502,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "carolina_navarrete_rubio",
              "id_candidato_servel": 17459257,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "josefa_javiera_del_pilar_balmaceda_vasquez",
              "id_candidato_servel": 17459786,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "jorge_carrillo_villalobos",
              "id_candidato_servel": 18390168,
              "genero": "M",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            },
            {
              "id_candidato": "etty_scarlette_solis_candia",
              "id_candidato_servel": 18411946,
              "genero": "F",
              "votes": 0,
              "percentage": 0,
              "winner": false,
              "por_paridad": false
            }
          ]
        }
      ]
    },
    {
      "circunscripcion": "17",
      "resultados": [
        {
          "id_candidato": "alihuen_antileo_navarrete",
          "id_candidato_servel": 8766295,
          "id_pacto": 999,
          "id_partido": 99,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        },
        {
          "id_candidato": "julio_nelson_marileo_calfuqueo",
          "id_candidato_servel": 13237807,
          "id_pacto": 999,
          "id_partido": 99,
          "genero": "M",
          "votes": 0,
          "percentage": 0,
          "winner": false,
          "por_paridad": false
        }
      ],
      "comunas": []
    }
  ]
  `)

export default ganadoresCircunscripcionEmpty
